// import React, { useEffect, useMemo, useState } from "react";
// import "./Locations.css";

// const API_BASE = "http://localhost:4001";
// const DEFAULT_COUNTRY_CODE = "BD";

// function fmtDate(d) {
//   if (!d) return "—";
//   try {
//     return new Date(d).toLocaleString();
//   } catch {
//     return d;
//   }
// }

// function StatusPill({ active }) {
//   return (
//     <span className={`status-pill ${active ? "active" : "inactive"}`}>
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// }

// function Modal({ title, onClose, children }) {
//   return (
//     <div className="modal-backdrop" onClick={onClose}>
//       <div
//         className="modal-content"
//         onClick={(e) => e.stopPropagation()}
//         role="dialog"
//       >
//         <div className="modal-header">
//           <h3>{title}</h3>
//           <button className="icon-btn" onClick={onClose} aria-label="Close">
//             ✕
//           </button>
//         </div>
//         <div className="modal-body">{children}</div>
//       </div>
//     </div>
//   );
// }

// export default function Locations() {
//   const [loading, setLoading] = useState(true);
//   const [refreshKey, setRefreshKey] = useState(0);

//   // country/division/area data
//   const [country, setCountry] = useState(null); // selected country (BD preferred)
//   const [divisions, setDivisions] = useState([]); // [{id,name,code,is_active,...}]
//   const [areas, setAreas] = useState([]); // flattened areas with division fields

//   // UI state
//   const [activeTab, setActiveTab] = useState("areas"); // "areas" | "divisions"

//   // status modal (generic for area/division/country)
//   const [statusModalOpen, setStatusModalOpen] = useState(false);
//   const [statusTarget, setStatusTarget] = useState(null); // { type, id, name, code?, is_active, parentActive?, parentName?, parentId? }
//   const [statusForm, setStatusForm] = useState({ is_active: false, updated_by: "" });

//   // add area modal
//   const [addAreaOpen, setAddAreaOpen] = useState(false);
//   const [addAreaForm, setAddAreaForm] = useState({
//     divisionId: "",
//     areaName: "",
//     is_active: false,
//     created_by: "",
//   });

//   // add division modal
//   const [addDivisionOpen, setAddDivisionOpen] = useState(false);
//   const [addDivisionForm, setAddDivisionForm] = useState({
//     name: "",
//     code: "",
//     is_active: false,
//     created_by: "",
//   });

//   // fetch tree & build state
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const res = await fetch(`${API_BASE}/locations/tree`);
//         if (!res.ok) throw new Error("Failed to load locations tree");
//         const data = await res.json();

//         // choose country (prefer BD)
//         const selected =
//           data.find(
//             (c) => (c.country?.code || "").toUpperCase() === DEFAULT_COUNTRY_CODE
//           ) || data[0];

//         if (!selected) {
//           // nothing in DB yet — show empty placeholders
//           if (!mounted) return;
//           setCountry(null);
//           setDivisions([]);
//           setAreas([]);
//           setLoading(false);
//           return;
//         }

//         const c = {
//           id: selected.country.Id,
//           name: selected.country.name,
//           code: selected.country.code,
//           is_active: selected.country.is_active,
//           created_by: selected.country.created_by,
//           updated_by: selected.country.updated_by,
//           created_at: selected.country.created_at,
//           updated_at: selected.country.updated_at,
//         };

//         const divs =
//           (selected.divisions || []).map((d) => ({
//             id: d.division.Id,
//             name: d.division.name,
//             code: d.division.code,
//             is_active: d.division.is_active,
//             created_by: d.division.created_by,
//             updated_by: d.division.updated_by,
//             created_at: d.division.created_at,
//             updated_at: d.division.updated_at,
//           })) || [];

//         const flatAreas = [];
//         (selected.divisions || []).forEach((d) => {
//           const division = d.division;
//           (d.areas || []).forEach((a) => {
//             flatAreas.push({
//               id: a.Id,
//               areaName: a.name,
//               is_active: a.is_active,
//               created_by: a.created_by,
//               updated_by: a.updated_by,
//               created_at: a.created_at,
//               updated_at: a.updated_at,
//               divisionId: division.Id,
//               divisionName: division.name,
//               divisionCode: division.code,
//               divisionActive: division.is_active,
//             });
//           });
//         });

//         // sort nicely
//         divs.sort((a, b) => a.name.localeCompare(b.name));
//         flatAreas.sort((x, y) => {
//           const d = x.divisionName.localeCompare(y.divisionName);
//           return d !== 0 ? d : x.areaName.localeCompare(y.areaName);
//         });

//         if (!mounted) return;
//         setCountry(c);
//         setDivisions(divs);
//         setAreas(flatAreas);
//       } catch (e) {
//         console.error(e);
//         alert("Failed to load locations. Check server/routes.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [refreshKey]);

//   // ===== status modals openers =====
//   const openAreaStatus = (row) => {
//     setStatusTarget({
//       type: "area",
//       id: row.id,
//       name: row.areaName,
//       is_active: !!row.is_active,
//       parentActive: !!row.divisionActive,
//       parentName: row.divisionName,
//       parentId: row.divisionId,
//     });
//     setStatusForm({ is_active: !!row.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openDivisionStatus = (d) => {
//     setStatusTarget({
//       type: "division",
//       id: d.id,
//       name: d.name,
//       code: d.code,
//       is_active: !!d.is_active,
//       parentActive: country ? !!country.is_active : true,
//       parentName: country ? `${country.name} (${country.code})` : "—",
//       parentId: country ? country.id : null,
//     });
//     setStatusForm({ is_active: !!d.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openCountryStatus = () => {
//     if (!country) return;
//     setStatusTarget({
//       type: "country",
//       id: country.id,
//       name: `${country.name} (${country.code})`,
//       is_active: !!country.is_active,
//     });
//     setStatusForm({ is_active: !!country.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   // ===== submit status =====
//   const submitStatus = async (e) => {
//     e.preventDefault();
//     if (!statusTarget) return;

//     try {
//       const res = await fetch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           is_active: statusForm.is_active,
//           updated_by: statusForm.updated_by || "admin",
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to update status");
//       }
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   // quick action: activate parent and then area (useful in Area modal)
//   const quickActivateParentThenArea = async () => {
//     if (!statusTarget || statusTarget.type !== "area") return;
//     const divisionId = statusTarget.parentId;
//     try {
//       // 1) turn division ON
//       const r1 = await fetch(`${API_BASE}/locations/${divisionId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ is_active: true, updated_by: statusForm.updated_by || "admin" }),
//       });
//       if (!r1.ok) {
//         const msg = await r1.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to activate parent division");
//       }
//       // 2) turn area ON
//       const r2 = await fetch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ is_active: true, updated_by: statusForm.updated_by || "admin" }),
//       });
//       if (!r2.ok) {
//         const msg = await r2.json().catch(() => ({}));
//         throw new Error(msg?.error || "Parent activated but failed to activate area");
//       }
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message); // this will include "Activate parent first" if country is inactive
//     }
//   };

//   // ===== add area =====
//   const openAddArea = () => {
//     setAddAreaForm({ divisionId: "", areaName: "", is_active: false, created_by: "" });
//     setAddAreaOpen(true);
//   };
//   const submitAddArea = async (e) => {
//     e.preventDefault();
//     if (!addAreaForm.divisionId || !addAreaForm.areaName.trim()) {
//       alert("Please select a division and enter area name.");
//       return;
//     }
//     try {
//       const res = await fetch(`${API_BASE}/locations/area`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           divisionId: Number(addAreaForm.divisionId),
//           name: addAreaForm.areaName.trim(),
//           created_by: addAreaForm.created_by || "admin",
//           is_active: !!addAreaForm.is_active,
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to create area");
//       }
//       setAddAreaOpen(false);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   // ===== add division =====
//   const openAddDivision = () => {
//     setAddDivisionForm({ name: "", code: "", is_active: false, created_by: "" });
//     setAddDivisionOpen(true);
//   };
//   const submitAddDivision = async (e) => {
//     e.preventDefault();
//     if (!country) {
//       alert("Please create/activate a country first.");
//       return;
//     }
//     if (!addDivisionForm.name.trim() || !addDivisionForm.code.trim()) {
//       alert("Please enter division name and code.");
//       return;
//     }
//     try {
//       const res = await fetch(`${API_BASE}/locations/division`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           countryCode: country.code || DEFAULT_COUNTRY_CODE,
//           name: addDivisionForm.name.trim(),
//           code: addDivisionForm.code.trim(),
//           created_by: addDivisionForm.created_by || "admin",
//           is_active: !!addDivisionForm.is_active,
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to create division");
//       }
//       setAddDivisionOpen(false);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   // table rows
//   const areaRows = useMemo(
//     () => areas.map((r, idx) => ({ idx: idx + 1, ...r })),
//     [areas]
//   );
//   const divisionRows = useMemo(
//     () =>
//       divisions.map((d, idx) => ({
//         idx: idx + 1,
//         ...d,
//       })),
//     [divisions]
//   );

//   return (
//     <div className="locations-page">
//       <div className="header">
//         <h2>Locations</h2>
//       </div>

//       {/* Country status bar */}
//       <div className="country-bar">
//         {country ? (
//           <>
//             <div className="country-info">
//               <div className="country-title">
//                 Country:&nbsp;<strong>{country.name}</strong>
//                 {country.code ? <span>&nbsp;({country.code})</span> : null}
//               </div>
//               <StatusPill active={country.is_active} />
//             </div>
//             <div className="country-actions">
//               <button className="secondary-btn" onClick={openCountryStatus}>
//                 Set Country Status
//               </button>
//             </div>
//           </>
//         ) : (
//           <div className="empty">
//             No country found. Seed your locations (create Country & Divisions).
//           </div>
//         )}
//       </div>

//       {/* Tabs */}
//       <div className="tabs">
//         <button
//           className={`tab-btn ${activeTab === "areas" ? "active" : ""}`}
//           onClick={() => setActiveTab("areas")}
//         >
//           Areas
//         </button>
//         <button
//           className={`tab-btn ${activeTab === "divisions" ? "active" : ""}`}
//           onClick={() => setActiveTab("divisions")}
//         >
//           Divisions
//         </button>
//       </div>

//       {/* Tab content */}
//       {activeTab === "areas" ? (
//         <div className="card">
//           <div className="card-head">
//             <h3>Areas</h3>
//             <button className="primary-btn" onClick={openAddArea}>+ Add Area</button>
//           </div>
//           {loading ? (
//             <div className="loading">Loading…</div>
//           ) : areaRows.length === 0 ? (
//             <div className="empty">No areas found. Click “Add Area” to create one.</div>
//           ) : (
//             <div className="table-wrap">
//               <table className="locations-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Division</th>
//                     <th>Code</th>
//                     <th>Area</th>
//                     <th>Status</th>
//                     <th>Created by</th>
//                     <th>Updated by</th>
//                     <th>Created at</th>
//                     <th>Updated at</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {areaRows.map((row) => (
//                     <tr key={row.id}>
//                       <td>{row.idx}</td>
//                       <td>{row.divisionName}</td>
//                       <td>{row.divisionCode || "—"}</td>
//                       <td>{row.areaName}</td>
//                       <td><StatusPill active={row.is_active} /></td>
//                       <td>{row.created_by || "—"}</td>
//                       <td>{row.updated_by || "—"}</td>
//                       <td>{fmtDate(row.created_at)}</td>
//                       <td>{fmtDate(row.updated_at)}</td>
//                       <td>
//                         <button className="secondary-btn" onClick={() => openAreaStatus(row)}>
//                           Set Status
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       ) : (
//         <div className="card">
//           <div className="card-head">
//             <h3>Divisions</h3>
//             <button className="primary-btn" onClick={openAddDivision}>+ Add Division</button>
//           </div>
//           {loading ? (
//             <div className="loading">Loading…</div>
//           ) : divisionRows.length === 0 ? (
//             <div className="empty">No divisions found. Click “Add Division” to create one.</div>
//           ) : (
//             <div className="table-wrap">
//               <table className="locations-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Division</th>
//                     <th>Code</th>
//                     <th>Status</th>
//                     <th>Created by</th>
//                     <th>Updated by</th>
//                     <th>Created at</th>
//                     <th>Updated at</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {divisionRows.map((d) => (
//                     <tr key={d.id}>
//                       <td>{d.idx}</td>
//                       <td>{d.name}</td>
//                       <td>{d.code || "—"}</td>
//                       <td><StatusPill active={d.is_active} /></td>
//                       <td>{d.created_by || "—"}</td>
//                       <td>{d.updated_by || "—"}</td>
//                       <td>{fmtDate(d.created_at)}</td>
//                       <td>{fmtDate(d.updated_at)}</td>
//                       <td>
//                         <button className="secondary-btn" onClick={() => openDivisionStatus(d)}>
//                           Set Status
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Status Modal (generic) */}
//       {statusModalOpen && statusTarget && (
//         <Modal
//           title={`Update Status: ${
//             statusTarget.type === "country"
//               ? statusTarget.name
//               : statusTarget.type === "division"
//               ? `${statusTarget.name}${statusTarget.code ? ` (${statusTarget.code})` : ""}`
//               : statusTarget.name
//           }`}
//           onClose={() => setStatusModalOpen(false)}
//         >
//           <form onSubmit={submitStatus} className="form-grid">
//             {statusTarget.type === "area" && (
//               <>
//                 <div className="form-row">
//                   <label>Division</label>
//                   <input value={statusTarget.parentName || "—"} disabled />
//                 </div>
//               </>
//             )}
//             {statusTarget.type === "division" && (
//               <div className="form-row">
//                 <label>Country</label>
//                 <input value={statusTarget.parentName || "—"} disabled />
//               </div>
//             )}

//             <div className="form-row">
//               <label>{statusTarget.type === "area" ? "Area" : "Name"}</label>
//               <input
//                 value={statusTarget.name}
//                 disabled
//               />
//             </div>

//             {statusTarget.code !== undefined && statusTarget.type !== "country" && (
//               <div className="form-row">
//                 <label>Code</label>
//                 <input value={statusTarget.code || "—"} disabled />
//               </div>
//             )}

//             <div className="form-row">
//               <label>Status</label>
//               <div className="radio-row">
//                 <label className="radio">
//                   <input
//                     type="radio"
//                     name="status"
//                     checked={statusForm.is_active === true}
//                     onChange={() => setStatusForm((f) => ({ ...f, is_active: true }))}
//                   />
//                   Active
//                 </label>
//                 <label className="radio">
//                   <input
//                     type="radio"
//                     name="status"
//                     checked={statusForm.is_active === false}
//                     onChange={() => setStatusForm((f) => ({ ...f, is_active: false }))}
//                   />
//                   Inactive
//                 </label>
//               </div>

//               {statusForm.is_active && statusTarget.parentActive === false && (
//                 <p className="hint warn">
//                   Parent is inactive. Activate the parent first, otherwise this cannot be turned on.
//                 </p>
//               )}
//             </div>

//             <div className="form-row">
//               <label>{statusTarget.type === "country" ? "Updated by" : "Updated by"}</label>
//               <input
//                 placeholder="admin name (optional)"
//                 value={statusForm.updated_by}
//                 onChange={(e) =>
//                   setStatusForm((f) => ({ ...f, updated_by: e.target.value }))
//                 }
//               />
//             </div>

//             <div className="modal-actions">
//               {/* Quick activate parent & area path */}
//               {statusTarget.type === "area" &&
//                 statusForm.is_active &&
//                 statusTarget.parentActive === false && (
//                   <button
//                     type="button"
//                     className="secondary-btn"
//                     onClick={quickActivateParentThenArea}
//                     title="Activate division first, then this area"
//                   >
//                     Activate Division & Save
//                   </button>
//                 )}
//               <button
//                 type="button"
//                 className="ghost-btn"
//                 onClick={() => setStatusModalOpen(false)}
//               >
//                 Cancel
//               </button>
//               <button type="submit" className="primary-btn">Save</button>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {/* Add Area Modal */}
//       {addAreaOpen && (
//         <Modal title="Add Area" onClose={() => setAddAreaOpen(false)}>
//           <form onSubmit={submitAddArea} className="form-grid">
//             <div className="form-row">
//               <label>Division</label>
//               <select
//                 value={addAreaForm.divisionId}
//                 onChange={(e) =>
//                   setAddAreaForm((f) => ({ ...f, divisionId: e.target.value }))
//                 }
//               >
//                 <option value="">— Select Division —</option>
//                 {divisions.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.name} {d.code ? `(${d.code})` : ""}{!d.is_active ? " — INACTIVE" : ""}
//                   </option>
//                 ))}
//               </select>
//               <p className="hint">
//                 You can add an area under an inactive division, but it won't be visible until the division is activated.
//               </p>
//             </div>
//             <div className="form-row">
//               <label>Area name</label>
//               <input
//                 placeholder="e.g., Banani"
//                 value={addAreaForm.areaName}
//                 onChange={(e) =>
//                   setAddAreaForm((f) => ({ ...f, areaName: e.target.value }))
//                 }
//               />
//             </div>
//             <div className="form-row">
//               <label>Initial Status</label>
//               <label className="switch">
//                 <input
//                   type="checkbox"
//                   checked={addAreaForm.is_active}
//                   onChange={(e) =>
//                     setAddAreaForm((f) => ({ ...f, is_active: e.target.checked }))
//                   }
//                 />
//                 <span className="switch-slider" />
//                 <span className="switch-label">
//                   {addAreaForm.is_active ? "Active" : "Inactive"}
//                 </span>
//               </label>
//             </div>
//             <div className="form-row">
//               <label>Created by</label>
//               <input
//                 placeholder="admin name (optional)"
//                 value={addAreaForm.created_by}
//                 onChange={(e) =>
//                   setAddAreaForm((f) => ({ ...f, created_by: e.target.value }))
//                 }
//               />
//             </div>
//             <div className="modal-actions">
//               <button type="button" className="ghost-btn" onClick={() => setAddAreaOpen(false)}>
//                 Cancel
//               </button>
//               <button type="submit" className="primary-btn">Create</button>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {/* Add Division Modal */}
//       {addDivisionOpen && (
//         <Modal title="Add Division" onClose={() => setAddDivisionOpen(false)}>
//           <form onSubmit={submitAddDivision} className="form-grid">
//             <div className="form-row">
//               <label>Country</label>
//               <input value={country ? `${country.name} (${country.code})` : "—"} disabled />
//             </div>
//             <div className="form-row">
//               <label>Division name</label>
//               <input
//                 placeholder="e.g., Dhaka"
//                 value={addDivisionForm.name}
//                 onChange={(e) =>
//                   setAddDivisionForm((f) => ({ ...f, name: e.target.value }))
//                 }
//               />
//             </div>
//             <div className="form-row">
//               <label>Division code</label>
//               <input
//                 placeholder="e.g., DHA"
//                 value={addDivisionForm.code}
//                 onChange={(e) =>
//                   setAddDivisionForm((f) => ({ ...f, code: e.target.value }))
//                 }
//               />
//             </div>
//             <div className="form-row">
//               <label>Initial Status</label>
//               <label className="switch">
//                 <input
//                   type="checkbox"
//                   checked={addDivisionForm.is_active}
//                   onChange={(e) =>
//                     setAddDivisionForm((f) => ({ ...f, is_active: e.target.checked }))
//                   }
//                 />
//                 <span className="switch-slider" />
//                 <span className="switch-label">
//                   {addDivisionForm.is_active ? "Active" : "Inactive"}
//                 </span>
//               </label>
//               {!country?.is_active && addDivisionForm.is_active && (
//                 <p className="hint warn">Country is inactive; you must activate it first.</p>
//               )}
//             </div>
//             <div className="form-row">
//               <label>Created by</label>
//               <input
//                 placeholder="admin name (optional)"
//                 value={addDivisionForm.created_by}
//                 onChange={(e) =>
//                   setAddDivisionForm((f) => ({ ...f, created_by: e.target.value }))
//                 }
//               />
//             </div>
//             <div className="modal-actions">
//               <button type="button" className="ghost-btn" onClick={() => setAddDivisionOpen(false)}>
//                 Cancel
//               </button>
//               <button type="submit" className="primary-btn">Create</button>
//             </div>
//           </form>
//         </Modal>
//       )}
//     </div>
//   );
// }

// **** From Gpt **** //



// ***** from poe ***** //
// import React, { useEffect, useMemo, useState } from "react";
// import "./Locations.css";

// const API_BASE = "http://localhost:4001";
// const DEFAULT_COUNTRY_CODE = "BD";

// function fmtDate(d) {
//   if (!d) return "--";
//   try {
//     return new Date(d).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   } catch {
//     return d;
//   }
// }

// function StatusBadge({ active, size = "sm" }) {
//   return (
//     <span className={`status-badge ${active ? "active" : "inactive"} ${size}`}>
//       <span className="status-dot"></span>
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// }

// function Modal({ title, onClose, children, size = "md" }) {
//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className={`modal-container ${size}`}
//         onClick={(e) => e.stopPropagation()}
//         role="dialog"
//       >
//         <div className="modal-header">
//           <div className="modal-title">
//             <h3>{title}</h3>
//           </div>
//           <button className="modal-close-btn" onClick={onClose} aria-label="Close">
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <line x1="18" y1="6" x2="6" y2="18"></line>
//               <line x1="6" y1="6" x2="18" y2="18"></line>
//             </svg>
//           </button>
//         </div>
//         <div className="modal-content">{children}</div>
//       </div>
//     </div>
//   );
// }

// export default function Locations() {
//   const [loading, setLoading] = useState(true);
//   const [refreshKey, setRefreshKey] = useState(0);

//   // country/division/area data
//   const [country, setCountry] = useState(null);
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);

//   // UI state
//   const [activeTab, setActiveTab] = useState("areas");

//   // status modal
//   const [statusModalOpen, setStatusModalOpen] = useState(false);
//   const [statusTarget, setStatusTarget] = useState(null);
//   const [statusForm, setStatusForm] = useState({ is_active: false, updated_by: "" });

//   // add area modal
//   const [addAreaOpen, setAddAreaOpen] = useState(false);
//   const [addAreaForm, setAddAreaForm] = useState({
//     divisionId: "",
//     areaName: "",
//     is_active: false,
//     created_by: "",
//   });

//   // add division modal
//   const [addDivisionOpen, setAddDivisionOpen] = useState(false);
//   const [addDivisionForm, setAddDivisionForm] = useState({
//     name: "",
//     code: "",
//     is_active: false,
//     created_by: "",
//   });

//   // fetch tree & build state
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const res = await fetch(`${API_BASE}/locations/tree`);
//         if (!res.ok) throw new Error("Failed to load locations tree");
//         const data = await res.json();

//         const selected =
//           data.find(
//             (c) => (c.country?.code || "").toUpperCase() === DEFAULT_COUNTRY_CODE
//           ) || data[0];

//         if (!selected) {
//           if (!mounted) return;
//           setCountry(null);
//           setDivisions([]);
//           setAreas([]);
//           setLoading(false);
//           return;
//         }

//         const c = {
//           id: selected.country.Id,
//           name: selected.country.name,
//           code: selected.country.code,
//           is_active: selected.country.is_active,
//           created_by: selected.country.created_by,
//           updated_by: selected.country.updated_by,
//           created_at: selected.country.created_at,
//           updated_at: selected.country.updated_at,
//         };

//         const divs =
//           (selected.divisions || []).map((d) => ({
//             id: d.division.Id,
//             name: d.division.name,
//             code: d.division.code,
//             is_active: d.division.is_active,
//             created_by: d.division.created_by,
//             updated_by: d.division.updated_by,
//             created_at: d.division.created_at,
//             updated_at: d.division.updated_at,
//           })) || [];

//         const flatAreas = [];
//         (selected.divisions || []).forEach((d) => {
//           const division = d.division;
//           (d.areas || []).forEach((a) => {
//             flatAreas.push({
//               id: a.Id,
//               areaName: a.name,
//               is_active: a.is_active,
//               created_by: a.created_by,
//               updated_by: a.updated_by,
//               created_at: a.created_at,
//               updated_at: a.updated_at,
//               divisionId: division.Id,
//               divisionName: division.name,
//               divisionCode: division.code,
//               divisionActive: division.is_active,
//             });
//           });
//         });

//         divs.sort((a, b) => a.name.localeCompare(b.name));
//         flatAreas.sort((x, y) => {
//           const d = x.divisionName.localeCompare(y.divisionName);
//           return d !== 0 ? d : x.areaName.localeCompare(y.areaName);
//         });

//         if (!mounted) return;
//         setCountry(c);
//         setDivisions(divs);
//         setAreas(flatAreas);
//       } catch (e) {
//         console.error(e);
//         alert("Failed to load locations. Check server/routes.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [refreshKey]);

//   // Modal handlers
//   const openAreaStatus = (row) => {
//     setStatusTarget({
//       type: "area",
//       id: row.id,
//       name: row.areaName,
//       is_active: !!row.is_active,
//       parentActive: !!row.divisionActive,
//       parentName: row.divisionName,
//       parentId: row.divisionId,
//     });
//     setStatusForm({ is_active: !!row.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openDivisionStatus = (d) => {
//     setStatusTarget({
//       type: "division",
//       id: d.id,
//       name: d.name,
//       code: d.code,
//       is_active: !!d.is_active,
//       parentActive: country ? !!country.is_active : true,
//       parentName: country ? `${country.name} (${country.code})` : "--",
//       parentId: country ? country.id : null,
//     });
//     setStatusForm({ is_active: !!d.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openCountryStatus = () => {
//     if (!country) return;
//     setStatusTarget({
//       type: "country",
//       id: country.id,
//       name: `${country.name} (${country.code})`,
//       is_active: !!country.is_active,
//     });
//     setStatusForm({ is_active: !!country.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   // Submit functions
//   const submitStatus = async (e) => {
//     e.preventDefault();
//     if (!statusTarget) return;

//     try {
//       const res = await fetch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           is_active: statusForm.is_active,
//           updated_by: statusForm.updated_by || "admin",
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to update status");
//       }
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   const quickActivateParentThenArea = async () => {
//     if (!statusTarget || statusTarget.type !== "area") return;
//     const divisionId = statusTarget.parentId;
//     try {
//       const r1 = await fetch(`${API_BASE}/locations/${divisionId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ is_active: true, updated_by: statusForm.updated_by || "admin" }),
//       });
//       if (!r1.ok) {
//         const msg = await r1.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to activate parent division");
//       }
//       const r2 = await fetch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ is_active: true, updated_by: statusForm.updated_by || "admin" }),
//       });
//       if (!r2.ok) {
//         const msg = await r2.json().catch(() => ({}));
//         throw new Error(msg?.error || "Parent activated but failed to activate area");
//       }
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   const openAddArea = () => {
//     setAddAreaForm({ divisionId: "", areaName: "", is_active: false, created_by: "" });
//     setAddAreaOpen(true);
//   };

//   const submitAddArea = async (e) => {
//     e.preventDefault();
//     if (!addAreaForm.divisionId || !addAreaForm.areaName.trim()) {
//       alert("Please select a division and enter area name.");
//       return;
//     }
//     try {
//       const res = await fetch(`${API_BASE}/locations/area`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           divisionId: Number(addAreaForm.divisionId),
//           name: addAreaForm.areaName.trim(),
//           created_by: addAreaForm.created_by || "admin",
//           is_active: !!addAreaForm.is_active,
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to create area");
//       }
//       setAddAreaOpen(false);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   const openAddDivision = () => {
//     setAddDivisionForm({ name: "", code: "", is_active: false, created_by: "" });
//     setAddDivisionOpen(true);
//   };

//   const submitAddDivision = async (e) => {
//     e.preventDefault();
//     if (!country) {
//       alert("Please create/activate a country first.");
//       return;
//     }
//     if (!addDivisionForm.name.trim() || !addDivisionForm.code.trim()) {
//       alert("Please enter division name and code.");
//       return;
//     }
//     try {
//       const res = await fetch(`${API_BASE}/locations/division`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           countryCode: country.code || DEFAULT_COUNTRY_CODE,
//           name: addDivisionForm.name.trim(),
//           code: addDivisionForm.code.trim(),
//           created_by: addDivisionForm.created_by || "admin",
//           is_active: !!addDivisionForm.is_active,
//         }),
//       });
//       if (!res.ok) {
//         const msg = await res.json().catch(() => ({}));
//         throw new Error(msg?.error || "Failed to create division");
//       }
//       setAddDivisionOpen(false);
//       setRefreshKey((k) => k + 1);
//     } catch (e) {
//       console.error(e);
//       alert(e.message);
//     }
//   };

//   const areaRows = useMemo(
//     () => areas.map((r, idx) => ({ idx: idx + 1, ...r })),
//     [areas]
//   );
//   const divisionRows = useMemo(
//     () => divisions.map((d, idx) => ({ idx: idx + 1, ...d })),
//     [divisions]
//   );

//   return (
//     <div className="locations-page">
//       {/* Header */}
//       <div className="page-header">
//         <div className="header-content">
//           <h1 className="page-title">Location Management</h1>
//           <p className="page-description">Manage divisions and areas for service coverage</p>
//         </div>
//       </div>

//       {/* Country Status Card */}
//       <div className="country-card">
//         <div className="country-header">
//           <div className="country-info">
//             <div className="country-flag">🇧🇩</div>
//             <div className="country-details">
//               <h3 className="country-name">
//                 {country ? country.name : "No Country"}
//                 {country?.code && <span className="country-code">({country.code})</span>}
//               </h3>
//               <div className="country-meta">
//                 {country ? (
//                   <>
//                     <StatusBadge active={country.is_active} />
//                     <span className="separator">•</span>
//                     <span className="meta-text">{divisions.length} divisions</span>
//                     <span className="separator">•</span>
//                     <span className="meta-text">{areas.length} areas</span>
//                   </>
//                 ) : (
//                   <span className="meta-text">Please create a country first</span>
//                 )}
//               </div>
//             </div>
//           </div>
//           {country && (
//             <button className="btn btn-outline btn-sm" onClick={openCountryStatus}>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <path d="M12 20h9"></path>
//                 <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//               </svg>
//               Manage Status
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Navigation Tabs */}
//       <div className="tab-navigation">
//         <div className="tab-list">
//           <button
//             className={`tab-button ${activeTab === "areas" ? "active" : ""}`}
//             onClick={() => setActiveTab("areas")}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
//               <circle cx="12" cy="10" r="3"></circle>
//             </svg>
//             Areas
//             <span className="tab-count">{areas.length}</span>
//           </button>
//           <button
//             className={`tab-button ${activeTab === "divisions" ? "active" : ""}`}
//             onClick={() => setActiveTab("divisions")}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
//               <polyline points="2,17 12,22 22,17"></polyline>
//               <polyline points="2,12 12,17 22,12"></polyline>
//             </svg>
//             Divisions
//             <span className="tab-count">{divisions.length}</span>
//           </button>
//         </div>
//       </div>

//       {/* Content Cards */}
//       {activeTab === "areas" ? (
//         <div className="content-card">
//           <div className="card-header">
//             <div className="header-left">
//               <h2 className="card-title">Service Areas</h2>
//               <p className="card-description">Manage specific service areas within divisions</p>
//             </div>
//             <button className="btn btn-primary" onClick={openAddArea}>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <line x1="12" y1="5" x2="12" y2="19"></line>
//                 <line x1="5" y1="12" x2="19" y2="12"></line>
//               </svg>
//               Add Area
//             </button>
//           </div>

//           {loading ? (
//             <div className="loading-state">
//               <div className="loading-spinner"></div>
//               <p>Loading areas...</p>
//             </div>
//           ) : areaRows.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//                   <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
//                   <circle cx="12" cy="10" r="3"></circle>
//                 </svg>
//               </div>
//               <h3>No areas found</h3>
//               <p>Start by creating your first service area</p>
//               <button className="btn btn-primary" onClick={openAddArea}>Add Area</button>
//             </div>
//           ) : (
//             <div className="table-container">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Area Name</th>
//                     <th>Division</th>
//                     <th>Status</th>
//                     <th>Created By</th>
//                     <th>Last Updated</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {areaRows.map((row) => (
//                     <tr key={row.id}>
//                       <td className="cell-number">{row.idx}</td>
//                       <td className="cell-primary">
//                         <div className="cell-content">
//                           <span className="primary-text">{row.areaName}</span>
//                         </div>
//                       </td>
//                       <td className="cell-secondary">
//                         <div className="division-info">
//                           <span className="division-name">{row.divisionName}</span>
//                           {row.divisionCode && <span className="division-code">({row.divisionCode})</span>}
//                           {!row.divisionActive && <span className="warning-text">Division Inactive</span>}
//                         </div>
//                       </td>
//                       <td><StatusBadge active={row.is_active} /></td>
//                       <td className="cell-secondary">{row.created_by || "--"}</td>
//                       <td className="cell-secondary">{fmtDate(row.updated_at)}</td>
//                       <td>
//                         <button 
//                           className="btn btn-ghost btn-sm" 
//                           onClick={() => openAreaStatus(row)}
//                         >
//                           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M12 20h9"></path>
//                             <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//                           </svg>
//                           Edit
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       ) : (
//         <div className="content-card">
//           <div className="card-header">
//             <div className="header-left">
//               <h2 className="card-title">Divisions</h2>
//               <p className="card-description">Manage major administrative divisions</p>
//             </div>
//             <button className="btn btn-primary" onClick={openAddDivision}>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <line x1="12" y1="5" x2="12" y2="19"></line>
//                 <line x1="5" y1="12" x2="19" y2="12"></line>
//               </svg>
//               Add Division
//             </button>
//           </div>

//           {loading ? (
//             <div className="loading-state">
//               <div className="loading-spinner"></div>
//               <p>Loading divisions...</p>
//             </div>
//           ) : divisionRows.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//                   <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
//                   <polyline points="2,17 12,22 22,17"></polyline>
//                   <polyline points="2,12 12,17 22,12"></polyline>
//                 </svg>
//               </div>
//               <h3>No divisions found</h3>
//               <p>Start by creating your first division</p>
//               <button className="btn btn-primary" onClick={openAddDivision}>Add Division</button>
//             </div>
//           ) : (
//             <div className="table-container">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Division Name</th>
//                     <th>Code</th>
//                     <th>Status</th>
//                     <th>Areas</th>
//                     <th>Created By</th>
//                     <th>Last Updated</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {divisionRows.map((division) => {
//                     const areaCount = areas.filter(a => a.divisionId === division.id).length;
//                     const activeAreaCount = areas.filter(a => a.divisionId === division.id && a.is_active).length;
                    
//                     return (
//                       <tr key={division.id}>
//                         <td className="cell-number">{division.idx}</td>
//                         <td className="cell-primary">
//                           <div className="cell-content">
//                             <span className="primary-text">{division.name}</span>
//                           </div>
//                         </td>
//                         <td className="cell-secondary">
//                           <span className="code-badge">{division.code || "--"}</span>
//                         </td>
//                         <td><StatusBadge active={division.is_active} /></td>
//                         <td className="cell-secondary">
//                           <div className="area-stats">
//                             <span className="stats-text">{activeAreaCount}/{areaCount}</span>
//                             <span className="stats-label">active</span>
//                           </div>
//                         </td>
//                         <td className="cell-secondary">{division.created_by || "--"}</td>
//                         <td className="cell-secondary">{fmtDate(division.updated_at)}</td>
//                         <td>
//                           <button 
//                             className="btn btn-ghost btn-sm" 
//                             onClick={() => openDivisionStatus(division)}
//                           >
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                               <path d="M12 20h9"></path>
//                               <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//                             </svg>
//                             Edit
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Modals */}
//       {statusModalOpen && statusTarget && (
//         <Modal
//           title={`Update ${statusTarget.type === "country" ? "Country" : statusTarget.type === "division" ? "Division" : "Area"} Status`}
//           onClose={() => setStatusModalOpen(false)}
//           size="md"
//         >
//           <form onSubmit={submitStatus} className="modal-form">
//             <div className="form-section">
//               <div className="form-group">
//                 <label className="form-label">
//                   {statusTarget.type === "area" ? "Area Name" : statusTarget.type === "division" ? "Division Name" : "Country Name"}
//                 </label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   value={statusTarget.name}
//                   disabled
//                 />
//               </div>

//               {statusTarget.type !== "country" && (
//                 <div className="form-group">
//                   <label className="form-label">
//                     {statusTarget.type === "area" ? "Division" : "Country"}
//                   </label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     value={statusTarget.parentName || "--"}
//                     disabled
//                   />
//                   {statusTarget.parentActive === false && (
//                     <div className="form-hint warning">
//                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                         <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
//                         <line x1="12" y1="9" x2="12" y2="13"></line>
//                         <line x1="12" y1="17" x2="12.01" y2="17"></line>
//                       </svg>
//                       Parent is inactive. Activate parent first.
//                     </div>
//                   )}
//                 </div>
//               )}

//               <div className="form-group">
//                 <label className="form-label">Status</label>
//                 <div className="radio-group">
//                   <label className="radio-option">
//                     <input
//                       type="radio"
//                       name="status"
//                       checked={statusForm.is_active === true}
//                       onChange={() => setStatusForm((f) => ({ ...f, is_active: true }))}
//                     />
//                     <span className="radio-checkmark"></span>
//                     <span className="radio-label">Active</span>
//                   </label>
//                   <label className="radio-option">
//                     <input
//                       type="radio"
//                       name="status"
//                       checked={statusForm.is_active === false}
//                       onChange={() => setStatusForm((f) => ({ ...f, is_active: false }))}
//                     />
//                     <span className="radio-checkmark"></span>
//                     <span className="radio-label">Inactive</span>
//                   </label>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Updated By</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="Enter admin name (optional)"
//                   value={statusForm.updated_by}
//                   onChange={(e) => setStatusForm((f) => ({ ...f, updated_by: e.target.value }))}
//                 />
//               </div>
//             </div>

//             <div className="modal-actions">
//               {statusTarget.type === "area" && 
//                 statusForm.is_active && 
//                 statusTarget.parentActive === false && (
//                 <button
//                   type="button"
//                   className="btn btn-warning"
//                   onClick={quickActivateParentThenArea}
//                 >
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="m9 18 6-6-6-6"></path>
//                   </svg>
//                   Activate Division & Save
//                 </button>
//               )}
//               <button type="button" className="btn btn-ghost" onClick={() => setStatusModalOpen(false)}>
//                 Cancel
//               </button>
//               <button type="submit" className="btn btn-primary">
//                 Save Changes
//               </button>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {addAreaOpen && (
//         <Modal title="Add New Area" onClose={() => setAddAreaOpen(false)} size="md">
//           <form onSubmit={submitAddArea} className="modal-form">
//             <div className="form-section">
//               <div className="form-group">
//                 <label className="form-label">Division</label>
//                 <select
//                   className="form-select"
//                   value={addAreaForm.divisionId}
//                   onChange={(e) => setAddAreaForm((f) => ({ ...f, divisionId: e.target.value }))}
//                 >
//                   <option value="">Select a division</option>
//                   {divisions.map((d) => (
//                     <option key={d.id} value={d.id}>
//                       {d.name} {d.code ? `(${d.code})` : ""}{!d.is_active ? " - INACTIVE" : ""}
//                     </option>
//                   ))}
//                 </select>
//                 <div className="form-hint">
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <circle cx="12" cy="12" r="10"></circle>
//                     <path d="m9 12 2 2 4-4"></path>
//                   </svg>
//                   Areas can be added to inactive divisions but won't be visible until division is activated.
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Area Name</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="e.g., Banani, Gulshan, Dhanmondi"
//                   value={addAreaForm.areaName}
//                   onChange={(e) => setAddAreaForm((f) => ({ ...f, areaName: e.target.value }))}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Created By</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="Enter admin name (optional)"
//                   value={addAreaForm.created_by}
//                   onChange={(e) => setAddAreaForm((f) => ({ ...f, created_by: e.target.value }))}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="toggle-label">
//                   <input
//                     type="checkbox"
//                     className="toggle-input"
//                     checked={addAreaForm.is_active}
//                     onChange={(e) => setAddAreaForm((f) => ({ ...f, is_active: e.target.checked }))}
//                   />
//                   <span className="toggle-switch">
//                     <span className="toggle-handle"></span>
//                   </span>
//                   <span className="toggle-text">
//                     {addAreaForm.is_active ? "Active" : "Inactive"} on creation
//                   </span>
//                 </label>
//               </div>
//             </div>

//             <div className="modal-actions">
//               <button type="button" className="btn btn-ghost" onClick={() => setAddAreaOpen(false)}>
//                 Cancel
//               </button>
//               <button type="submit" className="btn btn-primary">
//                 Create Area
//               </button>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {addDivisionOpen && (
//         <Modal title="Add New Division" onClose={() => setAddDivisionOpen(false)} size="md">
//           <form onSubmit={submitAddDivision} className="modal-form">
//             <div className="form-section">
//               <div className="form-group">
//                 <label className="form-label">Country</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   value={country ? `${country.name} (${country.code})` : "No country available"}
//                   disabled
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Division Name</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="e.g., Dhaka, Chittagong, Rajshahi"
//                   value={addDivisionForm.name}
//                   onChange={(e) => setAddDivisionForm((f) => ({ ...f, name: e.target.value }))}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Division Code</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="e.g., DHK, CTG, RAJ"
//                   value={addDivisionForm.code}
//                   onChange={(e) => setAddDivisionForm((f) => ({ ...f, code: e.target.value.toUpperCase() }))}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">Created By</label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="Enter admin name (optional)"
//                   value={addDivisionForm.created_by}
//                   onChange={(e) => setAddDivisionForm((f) => ({ ...f, created_by: e.target.value }))}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="toggle-label">
//                   <input
//                     type="checkbox"
//                     className="toggle-input"
//                     checked={addDivisionForm.is_active}
//                     onChange={(e) => setAddDivisionForm((f) => ({ ...f, is_active: e.target.checked }))}
//                   />
//                   <span className="toggle-switch">
//                     <span className="toggle-handle"></span>
//                   </span>
//                   <span className="toggle-text">
//                     {addDivisionForm.is_active ? "Active" : "Inactive"} on creation
//                   </span>
//                 </label>
//                 {!country?.is_active && addDivisionForm.is_active && (
//                   <div className="form-hint warning">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                       <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
//                       <line x1="12" y1="9" x2="12" y2="13"></line>
//                       <line x1="12" y1="17" x2="12.01" y2="17"></line>
//                     </svg>
//                     Country is inactive. Activate country first.
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="modal-actions">
//               <button type="button" className="btn btn-ghost" onClick={() => setAddDivisionOpen(false)}>
//                 Cancel
//               </button>
//               <button type="submit" className="btn btn-primary">
//                 Create Division
//               </button>
//             </div>
//           </form>
//         </Modal>
//       )}
//     </div>
//   );
// }




// ***** from Grok ***** //
// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Card,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
//   Pagination,
// } from "react-bootstrap";
// import axios from "axios";
// import { FaPlus, FaPencilAlt } from "react-icons/fa";
// import "./Locations.css";

// const API_BASE = "http://localhost:4001";
// const DEFAULT_COUNTRY_CODE = "BD";

// function fmtDate(d) {
//   if (!d) return "—";
//   try {
//     return new Date(d).toLocaleString();
//   } catch {
//     return d;
//   }
// }

// function StatusPill({ active }) {
//   return (
//     <span className={`adminlocations-badge-${active ? "active" : "inactive"}`}>
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// }

// export default function Locations() {
//   const [loading, setLoading] = useState(true);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // country/division/area data
//   const [country, setCountry] = useState(null);
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);

//   // UI state
//   const [activeTab, setActiveTab] = useState("areas");

//   // status modal
//   const [statusModalOpen, setStatusModalOpen] = useState(false);
//   const [statusTarget, setStatusTarget] = useState(null);
//   const [statusForm, setStatusForm] = useState({ is_active: false, updated_by: "" });

//   // add area modal
//   const [addAreaOpen, setAddAreaOpen] = useState(false);
//   const [addAreaForm, setAddAreaForm] = useState({
//     divisionId: "",
//     areaName: "",
//     is_active: false,
//     created_by: "",
//   });

//   // add division modal
//   const [addDivisionOpen, setAddDivisionOpen] = useState(false);
//   const [addDivisionForm, setAddDivisionForm] = useState({
//     name: "",
//     code: "",
//     is_active: false,
//     created_by: "",
//   });

//   // fetch tree & build state
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(`${API_BASE}/locations/tree`);
//         const data = res.data;

//         // choose country (prefer BD)
//         const selected =
//           data.find(
//             (c) => (c.country?.code || "").toUpperCase() === DEFAULT_COUNTRY_CODE
//           ) || data[0];

//         if (!selected) {
//           if (!mounted) return;
//           setCountry(null);
//           setDivisions([]);
//           setAreas([]);
//           setLoading(false);
//           return;
//         }

//         const c = {
//           id: selected.country.Id,
//           name: selected.country.name,
//           code: selected.country.code,
//           is_active: selected.country.is_active,
//           created_by: selected.country.created_by,
//           updated_by: selected.country.updated_by,
//           created_at: selected.country.created_at,
//           updated_at: selected.country.updated_at,
//         };

//         const divs =
//           (selected.divisions || []).map((d) => ({
//             id: d.division.Id,
//             name: d.division.name,
//             code: d.division.code,
//             is_active: d.division.is_active,
//             created_by: d.division.created_by,
//             updated_by: d.division.updated_by,
//             created_at: d.division.created_at,
//             updated_at: d.division.updated_at,
//           })) || [];

//         const flatAreas = [];
//         (selected.divisions || []).forEach((d) => {
//           const division = d.division;
//           (d.areas || []).forEach((a) => {
//             flatAreas.push({
//               id: a.Id,
//               areaName: a.name,
//               is_active: a.is_active,
//               created_by: a.created_by,
//               updated_by: a.updated_by,
//               created_at: a.created_at,
//               updated_at: a.updated_at,
//               divisionId: division.Id,
//               divisionName: division.name,
//               divisionCode: division.code,
//               divisionActive: division.is_active,
//             });
//           });
//         });

//         divs.sort((a, b) => a.name.localeCompare(b.name));
//         flatAreas.sort((x, y) => {
//           const d = x.divisionName.localeCompare(y.divisionName);
//           return d !== 0 ? d : x.areaName.localeCompare(y.areaName);
//         });

//         if (!mounted) return;
//         setCountry(c);
//         setDivisions(divs);
//         setAreas(flatAreas);
//       } catch (e) {
//         console.error(e);
//         setErrorMessage("Failed to load locations. Check server/routes.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [refreshKey]);

//   // status modal openers
//   const openAreaStatus = (row) => {
//     setStatusTarget({
//       type: "area",
//       id: row.id,
//       name: row.areaName,
//       is_active: !!row.is_active,
//       parentActive: !!row.divisionActive,
//       parentName: row.divisionName,
//       parentId: row.divisionId,
//     });
//     setStatusForm({ is_active: !!row.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openDivisionStatus = (d) => {
//     setStatusTarget({
//       type: "division",
//       id: d.id,
//       name: d.name,
//       code: d.code,
//       is_active: !!d.is_active,
//       parentActive: country ? !!country.is_active : true,
//       parentName: country ? `${country.name} (${country.code})` : "—",
//       parentId: country ? country.id : null,
//     });
//     setStatusForm({ is_active: !!d.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openCountryStatus = () => {
//     if (!country) return;
//     setStatusTarget({
//       type: "country",
//       id: country.id,
//       name: `${country.name} (${country.code})`,
//       is_active: !!country.is_active,
//     });
//     setStatusForm({ is_active: !!country.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   // submit status
//   const submitStatus = async (e) => {
//     e.preventDefault();
//     if (!statusTarget) return;

//     try {
//       await axios.patch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         is_active: statusForm.is_active,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Status updated successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to update status");
//     }
//   };

//   // quick activate parent and area
//   const quickActivateParentThenArea = async () => {
//     if (!statusTarget || statusTarget.type !== "area") return;
//     const divisionId = statusTarget.parentId;
//     try {
//       await axios.patch(`${API_BASE}/locations/${divisionId}/status`, {
//         is_active: true,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       await axios.patch(`${API_BASE}/locations/${statusTarget.id}/status`, {
//         is_active: true,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Parent and area activated successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to activate");
//     }
//   };

//   // add area
//   const openAddArea = () => {
//     setAddAreaForm({ divisionId: "", areaName: "", is_active: false, created_by: "" });
//     setAddAreaOpen(true);
//   };

//   const submitAddArea = async (e) => {
//     e.preventDefault();
//     if (!addAreaForm.divisionId || !addAreaForm.areaName.trim()) {
//       setErrorMessage("Please select a division and enter area name.");
//       return;
//     }
//     try {
//       await axios.post(`${API_BASE}/locations/area`, {
//         divisionId: Number(addAreaForm.divisionId),
//         name: addAreaForm.areaName.trim(),
//         created_by: addAreaForm.created_by || "admin",
//         is_active: !!addAreaForm.is_active,
//       });
//       setAddAreaOpen(false);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Area created successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to create area");
//     }
//   };

//   // add division
//   const openAddDivision = () => {
//     setAddDivisionForm({ name: "", code: "", is_active: false, created_by: "" });
//     setAddDivisionOpen(true);
//   };

//   const submitAddDivision = async (e) => {
//     e.preventDefault();
//     if (!country) {
//       setErrorMessage("Please create/activate a country first.");
//       return;
//     }
//     if (!addDivisionForm.name.trim() || !addDivisionForm.code.trim()) {
//       setErrorMessage("Please enter division name and code.");
//       return;
//     }
//     try {
//       await axios.post(`${API_BASE}/locations/division`, {
//         countryCode: country.code || DEFAULT_COUNTRY_CODE,
//         name: addDivisionForm.name.trim(),
//         code: addDivisionForm.code.trim(),
//         created_by: addDivisionForm.created_by || "admin",
//         is_active: !!addDivisionForm.is_active,
//       });
//       setAddDivisionOpen(false);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Division created successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to create division");
//     }
//   };

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentAreas = areas.slice(indexOfFirstItem, indexOfLastItem);
//   const currentDivisions = divisions.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPagesAreas = Math.ceil(areas.length / itemsPerPage);
//   const totalPagesDivisions = Math.ceil(divisions.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <Container fluid className="adminlocations-container">
//       {errorMessage && (
//         <Alert
//           variant={errorMessage.includes("successfully") ? "success" : "danger"}
//           onClose={() => setErrorMessage("")}
//           dismissible
//           className="adminlocations-alert"
//         >
//           {errorMessage}
//         </Alert>
//       )}
//       <Card className="adminlocations-card">
//         <Card.Header className="adminlocations-header">
//           <h4 className="adminlocations-title">Locations</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Country status bar */}
//           <div className="adminlocations-country-bar">
//             {country ? (
//               <>
//                 <div className="adminlocations-country-info">
//                   <div className="adminlocations-country-title">
//                     Country:&nbsp;<strong>{country.name}</strong>
//                     {country.code ? <span>&nbsp;({country.code})</span> : null}
//                   </div>
//                   <StatusPill active={country.is_active} />
//                 </div>
//                 <div className="adminlocations-country-actions">
//                   <Button
//                     variant="outline-primary"
//                     size="sm"
//                     className="adminlocations-action-btn"
//                     onClick={openCountryStatus}
//                   >
//                     <FaPencilAlt size={16} /> Set Status
//                   </Button>
//                 </div>
//               </>
//             ) : (
//               <div className="adminlocations-empty">
//                 No country found. Seed your locations (create Country & Divisions).
//               </div>
//             )}
//           </div>

//           {/* Tabs */}
//           <div className="adminlocations-tabs">
//             <Button
//               variant={activeTab === "areas" ? "primary" : "outline-primary"}
//               className="adminlocations-tab-btn"
//               onClick={() => setActiveTab("areas")}
//             >
//               Areas
//             </Button>
//             <Button
//               variant={activeTab === "divisions" ? "primary" : "outline-primary"}
//               className="adminlocations-tab-btn"
//               onClick={() => setActiveTab("divisions")}
//             >
//               Divisions
//             </Button>
//           </div>

//           {/* Tab content */}
//           {activeTab === "areas" ? (
//             <>
//               <div className="adminlocations-card-head">
//                 <h3>Areas</h3>
//                 <Button className="adminlocations-add-btn" onClick={openAddArea}>
//                   <FaPlus size={20} /> Add Area
//                 </Button>
//               </div>
//               {loading ? (
//                 <div className="adminlocations-loading">Loading…</div>
//               ) : currentAreas.length === 0 ? (
//                 <div className="adminlocations-empty">
//                   No areas found. Click “Add Area” to create one.
//                 </div>
//               ) : (
//                 <>
//                   <div className="adminlocations-table-wrap">
//                     <Table striped hover size="sm" className="adminlocations-table">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Division</th>
//                           <th>Code</th>
//                           <th>Area</th>
//                           <th>Status</th>
//                           <th>Created by</th>
//                           <th>Updated by</th>
//                           <th>Created at</th>
//                           <th>Updated at</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentAreas.map((row, idx) => (
//                           <tr key={row.id}>
//                             <td>{indexOfFirstItem + idx + 1}</td>
//                             <td>{row.divisionName}</td>
//                             <td>{row.divisionCode || "—"}</td>
//                             <td>{row.areaName}</td>
//                             <td>
//                               <StatusPill active={row.is_active} />
//                             </td>
//                             <td>{row.created_by || "—"}</td>
//                             <td>{row.updated_by || "—"}</td>
//                             <td>{fmtDate(row.created_at)}</td>
//                             <td>{fmtDate(row.updated_at)}</td>
//                             <td>
//                               <Button
//                                 variant="none"
//                                 className="adminlocations-action-btn"
//                                 onClick={() => openAreaStatus(row)}
//                               >
//                                 <FaPencilAlt size={16} style={{ color: "#0d6efd" }} />
//                               </Button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </div>
//                   <Pagination className="adminlocations-pagination">
//                     <Pagination.First
//                       onClick={() => handlePageChange(1)}
//                       disabled={currentPage === 1}
//                     />
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     />
//                     {[...Array(totalPagesAreas)].map((_, index) => (
//                       <Pagination.Item
//                         key={index + 1}
//                         active={index + 1 === currentPage}
//                         onClick={() => handlePageChange(index + 1)}
//                       >
//                         {index + 1}
//                       </Pagination.Item>
//                     ))}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPagesAreas}
//                     />
//                     <Pagination.Last
//                       onClick={() => handlePageChange(totalPagesAreas)}
//                       disabled={currentPage === totalPagesAreas}
//                     />
//                   </Pagination>
//                 </>
//               )}
//             </>
//           ) : (
//             <>
//               <div className="adminlocations-card-head">
//                 <h3>Divisions</h3>
//                 <Button className="adminlocations-add-btn" onClick={openAddDivision}>
//                   <FaPlus size={20} /> Add Division
//                 </Button>
//               </div>
//               {loading ? (
//                 <div className="adminlocations-loading">Loading…</div>
//               ) : currentDivisions.length === 0 ? (
//                 <div className="adminlocations-empty">
//                   No divisions found. Click “Add Division” to create one.
//                 </div>
//               ) : (
//                 <>
//                   <div className="adminlocations-table-wrap">
//                     <Table striped hover size="sm" className="adminlocations-table">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Division</th>
//                           <th>Code</th>
//                           <th>Status</th>
//                           <th>Created by</th>
//                           <th>Updated by</th>
//                           <th>Created at</th>
//                           <th>Updated at</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentDivisions.map((d, idx) => (
//                           <tr key={d.id}>
//                             <td>{indexOfFirstItem + idx + 1}</td>
//                             <td>{d.name}</td>
//                             <td>{d.code || "—"}</td>
//                             <td>
//                               <StatusPill active={d.is_active} />
//                             </td>
//                             <td>{d.created_by || "—"}</td>
//                             <td>{d.updated_by || "—"}</td>
//                             <td>{fmtDate(d.created_at)}</td>
//                             <td>{fmtDate(d.updated_at)}</td>
//                             <td>
//                               <Button
//                                 variant="none"
//                                 className="adminlocations-action-btn"
//                                 onClick={() => openDivisionStatus(d)}
//                               >
//                                 <FaPencilAlt size={16} style={{ color: "#0d6efd" }} />
//                               </Button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </div>
//                   <Pagination className="adminlocations-pagination">
//                     <Pagination.First
//                       onClick={() => handlePageChange(1)}
//                       disabled={currentPage === 1}
//                     />
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     />
//                     {[...Array(totalPagesDivisions)].map((_, index) => (
//                       <Pagination.Item
//                         key={index + 1}
//                         active={index + 1 === currentPage}
//                         onClick={() => handlePageChange(index + 1)}
//                       >
//                         {index + 1}
//                       </Pagination.Item>
//                     ))}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPagesDivisions}
//                     />
//                     <Pagination.Last
//                       onClick={() => handlePageChange(totalPagesDivisions)}
//                       disabled={currentPage === totalPagesDivisions}
//                     />
//                   </Pagination>
//                 </>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Status Modal */}
//       <Modal
//         show={statusModalOpen}
//         onHide={() => setStatusModalOpen(false)}
//         centered
//         className="adminlocations-modal"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">
//             {`Update Status: ${
//               statusTarget?.type === "country"
//                 ? statusTarget.name
//                 : statusTarget?.type === "division"
//                 ? `${statusTarget.name}${statusTarget.code ? ` (${statusTarget.code})` : ""}`
//                 : statusTarget?.name
//             }`}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitStatus}>
//             {statusTarget?.type === "area" && (
//               <Form.Group controlId="formParentDivision" className="mb-3">
//                 <Form.Label className="adminlocations-form-label">Division</Form.Label>
//                 <Form.Control
//                   value={statusTarget.parentName || "—"}
//                   disabled
//                   className="adminlocations-form-control"
//                 />
//               </Form.Group>
//             )}
//             {statusTarget?.type === "division" && (
//               <Form.Group controlId="formParentCountry" className="mb-3">
//                 <Form.Label className="adminlocations-form-label">Country</Form.Label>
//                 <Form.Control
//                   value={statusTarget.parentName || "—"}
//                   disabled
//                   className="adminlocations-form-control"
//                 />
//               </Form.Group>
//             )}
//             <Form.Group controlId="formName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">
//                 {statusTarget?.type === "area" ? "Area" : "Name"}
//               </Form.Label>
//               <Form.Control
//                 value={statusTarget?.name}
//                 disabled
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             {statusTarget?.code !== undefined && statusTarget?.type !== "country" && (
//               <Form.Group controlId="formCode" className="mb-3">
//                 <Form.Label className="adminlocations-form-label">Code</Form.Label>
//                 <Form.Control
//                   value={statusTarget.code || "—"}
//                   disabled
//                   className="adminlocations-form-control"
//                 />
//               </Form.Group>
//             )}
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="status-switch"
//                 label={statusForm.is_active ? "Active" : "Inactive"}
//                 checked={statusForm.is_active}
//                 onChange={(e) => setStatusForm({ ...statusForm, is_active: e.target.checked })}
//                 className="adminlocations-form-switch"
//               />
//               {statusForm.is_active && statusTarget?.parentActive === false && (
//                 <Alert variant="warning" className="mt-2">
//                   Parent is inactive. Activate the parent first, otherwise this cannot be turned on.
//                 </Alert>
//               )}
//             </Form.Group>
//             <Form.Group controlId="formUpdatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Updated by</Form.Label>
//               <Form.Control
//                 placeholder="admin name (optional)"
//                 value={statusForm.updated_by}
//                 onChange={(e) =>
//                   setStatusForm({ ...statusForm, updated_by: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             {statusTarget?.type === "area" &&
//               statusForm.is_active &&
//               statusTarget.parentActive === false && (
//                 <Button
//                   variant="warning"
//                   className="adminlocations-footer-btn adminlocations-footer-btn-quick"
//                   onClick={quickActivateParentThenArea}
//                 >
//                   Activate Division & Save
//                 </Button>
//               )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setStatusModalOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitStatus}
//           >
//             Save
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Add Area Modal */}
//       <Modal
//         show={addAreaOpen}
//         onHide={() => setAddAreaOpen(false)}
//         centered
//         className="adminlocations-modal"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">Add Area</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitAddArea}>
//             <Form.Group controlId="formDivision" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division</Form.Label>
//               <Form.Select
//                 value={addAreaForm.divisionId}
//                 onChange={(e) =>
//                   setAddAreaForm({ ...addAreaForm, divisionId: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               >
//                 <option value="">— Select Division —</option>
//                 {divisions.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.name} {d.code ? `(${d.code})` : ""}{!d.is_active ? " — INACTIVE" : ""}
//                   </option>
//                 ))}
//               </Form.Select>
//               <Alert variant="info" className="mt-2">
//                 You can add an area under an inactive division, but it won't be visible until the division is activated.
//               </Alert>
//             </Form.Group>
//             <Form.Group controlId="formAreaName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Area Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g., Banani"
//                 value={addAreaForm.areaName}
//                 onChange={(e) =>
//                   setAddAreaForm({ ...addAreaForm, areaName: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Initial Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="add-area-switch"
//                 label={addAreaForm.is_active ? "Active" : "Inactive"}
//                 checked={addAreaForm.is_active}
//                 onChange={(e) =>
//                   setAddAreaForm({ ...addAreaForm, is_active: e.target.checked })
//                 }
//                 className="adminlocations-form-switch"
//               />
//             </Form.Group>
//             <Form.Group controlId="formCreatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Created by</Form.Label>
//               <Form.Control
//                 placeholder="admin name (optional)"
//                 value={addAreaForm.created_by}
//                 onChange={(e) =>
//                   setAddAreaForm({ ...addAreaForm, created_by: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setAddAreaOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitAddArea}
//           >
//             Create
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Add Division Modal */}
//       <Modal
//         show={addDivisionOpen}
//         onHide={() => setAddDivisionOpen(false)}
//         centered
//         className="adminlocations-modal"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">Add Division</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitAddDivision}>
//             <Form.Group controlId="formCountry" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Country</Form.Label>
//               <Form.Control
//                 value={country ? `${country.name} (${country.code})` : "—"}
//                 disabled
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formDivisionName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g., Dhaka"
//                 value={addDivisionForm.name}
//                 onChange={(e) =>
//                   setAddDivisionForm({ ...addDivisionForm, name: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formDivisionCode" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division Code</Form.Label>
//               <Form.Control
//                 placeholder="e.g., DHA"
//                 value={addDivisionForm.code}
//                 onChange={(e) =>
//                   setAddDivisionForm({ ...addDivisionForm, code: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Initial Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="add-division-switch"
//                 label={addDivisionForm.is_active ? "Active" : "Inactive"}
//                 checked={addDivisionForm.is_active}
//                 onChange={(e) =>
//                   setAddDivisionForm({ ...addDivisionForm, is_active: e.target.checked })
//                 }
//                 className="adminlocations-form-switch"
//               />
//               {!country?.is_active && addDivisionForm.is_active && (
//                 <Alert variant="warning" className="mt-2">
//                   Country is inactive; you must activate it first.
//                 </Alert>
//               )}
//             </Form.Group>
//             <Form.Group controlId="formCreatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Created by</Form.Label>
//               <Form.Control
//                 placeholder="admin name (optional)"
//                 value={addDivisionForm.created_by}
//                 onChange={(e) =>
//                   setAddDivisionForm({ ...addDivisionForm, created_by: e.target.value })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setAddDivisionOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitAddDivision}
//           >
//             Create
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// }




// ***** Updated Code (from G (7-sep-25) ***** //

// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Card,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
//   Pagination,
// } from "react-bootstrap";
// import axios from "axios";
// import { FaPlus, FaPencilAlt } from "react-icons/fa";
// import "./Locations.css";
// import { URL } from "../../../config";

// // const API_BASE = "http://localhost:4001";
// const DEFAULT_COUNTRY_CODE = "BD";

// // UPDATE: Prefer toLocaleString so time is reliably included everywhere
// function fmtDate(d) {
//   if (!d) return "--";
//   try {
//     return new Date(d).toLocaleString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   } catch {
//     return d;
//   }
// }

// function StatusPill({ active }) {
//   return (
//     <span className={`adminlocations-badge-${active ? "active" : "inactive"}`}>
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// }

// // UPDATE: toggle this if you want a soft data refresh when switching to Divisions
// // (uses setRefreshKey; safer than window.location.reload() which would reset the tab)
// const REFRESH_ON_DIVISIONS_TAB_CLICK = true;

// export default function Locations() {
//   const [loading, setLoading] = useState(true);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [errorMessage, setErrorMessage] = useState("");

//   // UPDATE: separate pagination states for Areas and Divisions
//   const [areasPage, setAreasPage] = useState(1);
//   const [divisionsPage, setDivisionsPage] = useState(1);
//   const itemsPerPage = 10;

//   // country/division/area data
//   const [country, setCountry] = useState(null);
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);

//   // UI state
//   const [activeTab, setActiveTab] = useState("areas");

//   // status modal
//   const [statusModalOpen, setStatusModalOpen] = useState(false);
//   const [statusTarget, setStatusTarget] = useState(null);
//   const [statusForm, setStatusForm] = useState({ is_active: false, updated_by: "" });

//   // add area modal
//   const [addAreaOpen, setAddAreaOpen] = useState(false);
//   const [addAreaForm, setAddAreaForm] = useState({
//     divisionId: "",
//     areaName: "",
//     is_active: false,
//     created_by: "",
//   });

//   // add division modal
//   const [addDivisionOpen, setAddDivisionOpen] = useState(false);
//   const [addDivisionForm, setAddDivisionForm] = useState({
//     name: "",
//     code: "",
//     is_active: false,
//     created_by: "",
//   });

//   // fetch tree & build state
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(`${URL}/locations/tree`);
//         const data = res.data;

//         const selected =
//           data.find(
//             (c) => (c.country?.code || "").toUpperCase() === DEFAULT_COUNTRY_CODE
//           ) || data[0];

//         if (!selected) {
//           if (!mounted) return;
//           setCountry(null);
//           setDivisions([]);
//           setAreas([]);
//           setLoading(false);
//           return;
//         }

//         const c = {
//           id: selected.country.Id,
//           name: selected.country.name,
//           code: selected.country.code,
//           is_active: selected.country.is_active,
//           created_by: selected.country.created_by,
//           updated_by: selected.country.updated_by,
//           created_at: selected.country.created_at,
//           updated_at: selected.country.updated_at,
//         };

//         const divs =
//           (selected.divisions || []).map((d) => ({
//             id: d.division.Id,
//             name: d.division.name,
//             code: d.division.code,
//             is_active: d.division.is_active,
//             created_by: d.division.created_by,
//             updated_by: d.division.updated_by,
//             created_at: d.division.created_at,
//             updated_at: d.division.updated_at,
//           })) || [];

//         const flatAreas = [];
//         (selected.divisions || []).forEach((d) => {
//           const division = d.division;
//           (d.areas || []).forEach((a) => {
//             flatAreas.push({
//               id: a.Id,
//               areaName: a.name,
//               is_active: a.is_active,
//               created_by: a.created_by,
//               updated_by: a.updated_by,
//               created_at: a.created_at,
//               updated_at: a.updated_at,
//               divisionId: division.Id,
//               divisionName: division.name,
//               divisionCode: division.code,
//               divisionActive: division.is_active,
//             });
//           });
//         });

//         divs.sort((a, b) => a.name.localeCompare(b.name));
//         flatAreas.sort((x, y) => {
//           const d = x.divisionName.localeCompare(y.divisionName);
//           return d !== 0 ? d : x.areaName.localeCompare(y.areaName);
//         });

//         if (!mounted) return;
//         setCountry(c);
//         setDivisions(divs);
//         setAreas(flatAreas);
//       } catch (e) {
//         console.error(e);
//         setErrorMessage("Failed to load locations. Check server/routes.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [refreshKey]);

//   // UPDATE: clamp areasPage when areas length changes
//   useEffect(() => {
//     const total = Math.max(1, Math.ceil(areas.length / itemsPerPage));
//     if (areasPage > total) setAreasPage(total);
//   }, [areas, itemsPerPage, areasPage]);

//   // UPDATE: clamp divisionsPage when divisions length changes
//   useEffect(() => {
//     const total = Math.max(1, Math.ceil(divisions.length / itemsPerPage));
//     if (divisionsPage > total) setDivisionsPage(total);
//   }, [divisions, itemsPerPage, divisionsPage]);

//   // Modal handlers
//   const openAreaStatus = (row) => {
//     setStatusTarget({
//       type: "area",
//       id: row.id,
//       name: row.areaName,
//       is_active: !!row.is_active,
//       parentActive: !!row.divisionActive,
//       parentName: row.divisionName,
//       parentId: row.divisionId,
//     });
//     setStatusForm({ is_active: !!row.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openDivisionStatus = (d) => {
//     setStatusTarget({
//       type: "division",
//       id: d.id,
//       name: d.name,
//       code: d.code,
//       is_active: !!d.is_active,
//       parentActive: country ? !!country.is_active : true,
//       parentName: country ? `${country.name} (${country.code})` : "--",
//       parentId: country ? country.id : null,
//     });
//     setStatusForm({ is_active: !!d.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   const openCountryStatus = () => {
//     if (!country) return;
//     setStatusTarget({
//       type: "country",
//       id: country.id,
//       name: `${country.name} (${country.code})`,
//       is_active: !!country.is_active,
//     });
//     setStatusForm({ is_active: !!country.is_active, updated_by: "" });
//     setStatusModalOpen(true);
//   };

//   // Submit functions
//   const submitStatus = async (e) => {
//     e.preventDefault();
//     if (!statusTarget) return;

//     try {
//       await axios.patch(`${URL}/locations/${statusTarget.id}/status`, {
//         is_active: statusForm.is_active,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Status updated successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to update status");
//     }
//   };

//   const quickActivateParentThenArea = async () => {
//     if (!statusTarget || statusTarget.type !== "area") return;
//     const divisionId = statusTarget.parentId;
//     try {
//       await axios.patch(`${URL}/locations/${divisionId}/status`, {
//         is_active: true,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       await axios.patch(`${URL}/locations/${statusTarget.id}/status`, {
//         is_active: true,
//         updated_by: statusForm.updated_by || "admin",
//       });
//       setStatusModalOpen(false);
//       setStatusTarget(null);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Parent and area activated successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to activate");
//     }
//   };

//   const openAddArea = () => {
//     setAddAreaForm({ divisionId: "", areaName: "", is_active: false, created_by: "" });
//     setAddAreaOpen(true);
//   };

//   const submitAddArea = async (e) => {
//     e.preventDefault();
//     if (!addAreaForm.divisionId || !addAreaForm.areaName.trim()) {
//       setErrorMessage("Please select a division and enter area name.");
//       return;
//     }
//     try {
//       await axios.post(`${URL}/locations/area`, {
//         divisionId: Number(addAreaForm.divisionId),
//         name: addAreaForm.areaName.trim(),
//         created_by: addAreaForm.created_by || "admin",
//         is_active: !!addAreaForm.is_active,
//       });
//       setAddAreaOpen(false);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Area created successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to create area");
//     }
//   };

//   const openAddDivision = () => {
//     setAddDivisionForm({ name: "", code: "", is_active: false, created_by: "" });
//     setAddDivisionOpen(true);
//   };

//   const submitAddDivision = async (e) => {
//     e.preventDefault();
//     if (!country) {
//       setErrorMessage("Please create/activate a country first.");
//       return;
//     }
//     if (!addDivisionForm.name.trim() || !addDivisionForm.code.trim()) {
//       setErrorMessage("Please enter division name and code.");
//       return;
//     }
//     try {
//       await axios.post(`${URL}/locations/division`, {
//         countryCode: country.code || DEFAULT_COUNTRY_CODE,
//         name: addDivisionForm.name.trim(),
//         code: addDivisionForm.code.trim(),
//         created_by: addDivisionForm.created_by || "admin",
//         is_active: !!addDivisionForm.is_active,
//       });
//       setAddDivisionOpen(false);
//       setRefreshKey((k) => k + 1);
//       setErrorMessage("Division created successfully.");
//     } catch (e) {
//       console.error(e);
//       setErrorMessage(e.response?.data?.error || "Failed to create division");
//     }
//   };

//   // UPDATE: compute paged rows per tab (separate paginations)
//   // Areas
//   const indexOfLastArea = areasPage * itemsPerPage;
//   const indexOfFirstArea = indexOfLastArea - itemsPerPage;
//   const currentAreas = areas.slice(indexOfFirstArea, indexOfLastArea);
//   const totalPagesAreas = Math.max(1, Math.ceil(areas.length / itemsPerPage));

//   // Divisions
//   const indexOfLastDivision = divisionsPage * itemsPerPage;
//   const indexOfFirstDivision = indexOfLastDivision - itemsPerPage;
//   const currentDivisions = divisions.slice(indexOfFirstDivision, indexOfLastDivision);
//   const totalPagesDivisions = Math.max(1, Math.ceil(divisions.length / itemsPerPage));

//   // UPDATE: safe type title for modal
//   const typeTitle = statusTarget
//     ? (statusTarget.type?.[0]?.toUpperCase() || "") + (statusTarget.type?.slice(1) || "")
//     : "";

//   return (
//     <Container fluid className="adminlocations-container">
//       {errorMessage && (
//         <Alert
//           variant={errorMessage.includes("successfully") ? "success" : "danger"}
//           onClose={() => setErrorMessage("")}
//           dismissible
//           className="adminlocations-alert"
//         >
//           {errorMessage}
//         </Alert>
//       )}
//       <Card className="adminlocations-card">
//         <Card.Header className="adminlocations-header">
//           <h4 className="adminlocations-title">Location Management</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Country status bar */}
//           <div className="adminlocations-country-bar">
//             {country ? (
//               <>
//                 <div className="adminlocations-country-info">
//                   <div className="adminlocations-country-title">
//                     Country:&nbsp;<strong>{country.name}</strong>
//                     {country.code ? <span>&nbsp;({country.code})</span> : null}
//                   </div>
//                   <StatusPill active={country.is_active} />
//                   <span className="ms-2">• {divisions.length} divisions • {areas.length} areas</span>
//                 </div>
//                 <div className="adminlocations-country-actions">
//                   {/* UPDATE: pill-style editable button */}
//                   <Button
//                     variant="none"
//                     className="adminlocations-edit-pill"
//                     onClick={openCountryStatus}
//                   >
//                     <FaPencilAlt className="me-2" /> Manage Status
//                   </Button>
//                 </div>
//               </>
//             ) : (
//               <div className="adminlocations-empty">
//                 No country found. Please create a country first.
//               </div>
//             )}
//           </div>

//           {/* Tabs */}
//           <div className="adminlocations-tabs">
//             <Button
//               variant={activeTab === "areas" ? "primary" : "outline-primary"}
//               className="adminlocations-tab-btn"
//               onClick={() => {
//                 // UPDATE: reset page on tab change
//                 setActiveTab("areas");
//                 setAreasPage(1);
//               }}
//             >
//               Areas ({areas.length})
//             </Button>
//             <Button
//               variant={activeTab === "divisions" ? "primary" : "outline-primary"}
//               className="adminlocations-tab-btn"
//               onClick={() => {
//                 // UPDATE: reset page on tab change
//                 setActiveTab("divisions");
//                 setDivisionsPage(1);
//                 if (REFRESH_ON_DIVISIONS_TAB_CLICK) {
//                   // soft refresh from server (keeps current tab)
//                   setRefreshKey((k) => k + 1);
//                   // If you truly want a full window reload, uncomment:
//                   // window.location.reload();
//                 }
//               }}
//             >
//               Divisions ({divisions.length})
//             </Button>
//           </div>

//           {/* Tab content */}
//           {activeTab === "areas" ? (
//             <>
//               <div className="adminlocations-card-head">
//                 <h3>Service Areas</h3>
//                 <Button className="adminlocations-add-btn" onClick={openAddArea}>
//                   <FaPlus size={20} /> Add Area
//                 </Button>
//               </div>
//               {loading ? (
//                 <div className="adminlocations-loading">Loading…</div>
//               ) : currentAreas.length === 0 ? (
//                 <div className="adminlocations-empty">
//                   No areas found. Start by creating your first service area.
//                   <Button variant="primary" className="ms-2" onClick={openAddArea}>Add Area</Button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="adminlocations-table-wrap">
//                     <Table striped hover size="sm" className="adminlocations-table">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Division</th>
//                           <th>Code</th>
//                           <th>Area</th>
//                           <th>Status</th>
//                           <th>Created by</th>
//                           <th>Updated by</th>
//                           <th>Created at</th>
//                           <th>Updated at</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentAreas.map((row, idx) => (
//                           <tr key={row.id}>
//                             <td>{indexOfFirstArea + idx + 1}</td>
//                             <td>
//                               {row.divisionName}
//                               {!row.divisionActive && (
//                                 <span className="badge bg-warning text-dark ms-2">Division Inactive</span>
//                               )}
//                             </td>
//                             <td>{row.divisionCode || "—"}</td>
//                             <td>{row.areaName}</td>
//                             <td>
//                               <StatusPill active={row.is_active} />
//                             </td>
//                             <td>{row.created_by || "—"}</td>
//                             <td>{row.updated_by || "—"}</td>
//                             <td>{fmtDate(row.created_at)}</td>
//                             <td>{fmtDate(row.updated_at)}</td>
//                             <td>
//                               <Button
//                                 variant="none"
//                                 className="adminlocations-action-btn"
//                                 onClick={() => openAreaStatus(row)}
//                               >
//                                 <FaPencilAlt size={16} style={{ color: "#0d6efd" }} />
//                               </Button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </div>
//                   {/* UPDATE: Areas pagination uses areasPage */}
//                   <Pagination className="adminlocations-pagination">
//                     <Pagination.First onClick={() => setAreasPage(1)} disabled={areasPage === 1} />
//                     <Pagination.Prev onClick={() => setAreasPage(areasPage - 1)} disabled={areasPage === 1} />
//                     {[...Array(totalPagesAreas).keys()].map((i) => (
//                       <Pagination.Item
//                         key={i + 1}
//                         active={i + 1 === areasPage}
//                         onClick={() => setAreasPage(i + 1)}
//                       >
//                         {i + 1}
//                       </Pagination.Item>
//                     ))}
//                     <Pagination.Next
//                       onClick={() => setAreasPage(areasPage + 1)}
//                       disabled={areasPage === totalPagesAreas}
//                     />
//                     <Pagination.Last
//                       onClick={() => setAreasPage(totalPagesAreas)}
//                       disabled={areasPage === totalPagesAreas}
//                     />
//                   </Pagination>
//                 </>
//               )}
//             </>
//           ) : (
//             <>
//               <div className="adminlocations-card-head">
//                 <h3>Divisions</h3>
//                 <Button className="adminlocations-add-btn" onClick={openAddDivision}>
//                   <FaPlus size={20} /> Add Division
//                 </Button>
//               </div>
//               {loading ? (
//                 <div className="adminlocations-loading">Loading…</div>
//               ) : currentDivisions.length === 0 ? (
//                 <div className="adminlocations-empty">
//                   No divisions found. Start by creating your first division.
//                   <Button variant="primary" className="ms-2" onClick={openAddDivision}>Add Division</Button>
//                 </div>
//               ) : (
//                 <>
//                   <div className="adminlocations-table-wrap">
//                     <Table striped hover size="sm" className="adminlocations-table">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Division</th>
//                           <th>Code</th>
//                           <th>Status</th>
//                           <th>Areas</th>
//                           <th>Created by</th>
//                           <th>Updated by</th>
//                           <th>Created at</th>
//                           <th>Updated at</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentDivisions.map((d, idx) => {
//                           const areaCount = areas.filter((a) => a.divisionId === d.id).length;
//                           const activeAreaCount = areas.filter((a) => a.is_active && a.divisionId === d.id).length;
//                           return (
//                             <tr key={d.id}>
//                               <td>{indexOfFirstDivision + idx + 1}</td>
//                               <td>{d.name}</td>
//                               <td>{d.code || "—"}</td>
//                               <td>
//                                 <StatusPill active={d.is_active} />
//                               </td>
//                               <td>{activeAreaCount}/{areaCount}</td>
//                               <td>{d.created_by || "—"}</td>
//                               <td>{d.updated_by || "—"}</td>
//                               <td>{fmtDate(d.created_at)}</td>
//                               <td>{fmtDate(d.updated_at)}</td>
//                               <td>
//                                 <Button
//                                   variant="none"
//                                   className="adminlocations-action-btn"
//                                   onClick={() => openDivisionStatus(d)}
//                                 >
//                                   <FaPencilAlt size={16} style={{ color: "#0d6efd" }} />
//                                 </Button>
//                               </td>
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </Table>
//                   </div>
//                   {/* UPDATE: Divisions pagination uses divisionsPage */}
//                   <Pagination className="adminlocations-pagination">
//                     <Pagination.First onClick={() => setDivisionsPage(1)} disabled={divisionsPage === 1} />
//                     <Pagination.Prev onClick={() => setDivisionsPage(divisionsPage - 1)} disabled={divisionsPage === 1} />
//                     {[...Array(totalPagesDivisions).keys()].map((i) => (
//                       <Pagination.Item
//                         key={i + 1}
//                         active={i + 1 === divisionsPage}
//                         onClick={() => setDivisionsPage(i + 1)}
//                       >
//                         {i + 1}
//                       </Pagination.Item>
//                     ))}
//                     <Pagination.Next
//                       onClick={() => setDivisionsPage(divisionsPage + 1)}
//                       disabled={divisionsPage === totalPagesDivisions}
//                     />
//                     <Pagination.Last
//                       onClick={() => setDivisionsPage(totalPagesDivisions)}
//                       disabled={divisionsPage === totalPagesDivisions}
//                     />
//                   </Pagination>
//                 </>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Status Modal */}
//       <Modal
//         show={statusModalOpen}
//         onHide={() => setStatusModalOpen(false)}
//         centered
//         className="adminlocations-modal"
//         dialogClassName="adminlocations-modal-xl"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">
//             {/* UPDATE: null-safe title */}
//             {statusTarget
//               ? `Update ${typeTitle} Status: ${
//                   statusTarget.type === "country"
//                     ? statusTarget.name
//                     : statusTarget.type === "division"
//                     ? `${statusTarget.name}${statusTarget.code ? ` (${statusTarget.code})` : ""}`
//                     : statusTarget.name
//                 }`
//               : "Update Status"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitStatus}>
//             {/* UPDATE: explicit guard + optional chaining in value */}
//             {statusTarget && statusTarget.type !== "country" && (
//               <Form.Group controlId="formParent" className="mb-3">
//                 <Form.Label className="adminlocations-form-label">
//                   {statusTarget?.type === "area" ? "Division" : "Country"}
//                 </Form.Label>
//                 <Form.Control
//                   value={statusTarget?.parentName ?? "--"}
//                   disabled
//                   className="adminlocations-form-control"
//                 />
//               </Form.Group>
//             )}
//             <Form.Group controlId="formName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">
//                 {statusTarget?.type === "area"
//                   ? "Area Name"
//                   : statusTarget?.type === "division"
//                   ? "Division Name"
//                   : "Country Name"}
//               </Form.Label>
//               <Form.Control value={statusTarget?.name || ""} disabled className="adminlocations-form-control" />
//             </Form.Group>
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="status-switch"
//                 label={statusForm.is_active ? "Active" : "Inactive"}
//                 checked={statusForm.is_active}
//                 onChange={(e) => setStatusForm({ ...statusForm, is_active: e.target.checked })}
//                 className="adminlocations-form-switch adminlocations-switch-label-down"
//               />
//               {statusForm.is_active && statusTarget?.parentActive === false && (
//                 <Alert variant="warning" className="mt-2">
//                   Parent is inactive. Activate the parent first, otherwise this cannot be turned on.
//                 </Alert>
//               )}
//             </Form.Group>
//             <Form.Group controlId="formUpdatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Updated by</Form.Label>
//               <Form.Control
//                 placeholder="Enter admin name (optional)"
//                 value={statusForm.updated_by}
//                 onChange={(e) => setStatusForm({ ...statusForm, updated_by: e.target.value })}
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             {statusTarget?.type === "area" &&
//               statusForm.is_active &&
//               statusTarget?.parentActive === false && (
//                 <Button
//                   variant="warning"
//                   className="adminlocations-footer-btn adminlocations-footer-btn-quick"
//                   onClick={quickActivateParentThenArea}
//                 >
//                   Activate Division & Save
//                 </Button>
//               )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setStatusModalOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitStatus}
//           >
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Add Area Modal */}
//       <Modal
//         show={addAreaOpen}
//         onHide={() => setAddAreaOpen(false)}
//         centered
//         className="adminlocations-modal"
//         dialogClassName="adminlocations-modal-xl"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">Add New Area</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitAddArea}>
//             <Form.Group controlId="formDivision" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division</Form.Label>
//               <Form.Select
//                 value={addAreaForm.divisionId}
//                 onChange={(e) => setAddAreaForm({ ...addAreaForm, divisionId: e.target.value })}
//                 className="adminlocations-form-control"
//               >
//                 <option value="">Select a division</option>
//                 {divisions.map((d) => (
//                   <option key={d.id} value={d.id}>
//                     {d.name} {d.code ? `(${d.code})` : ""}
//                     {!d.is_active ? " - INACTIVE" : ""}
//                   </option>
//                 ))}
//               </Form.Select>
//               <Alert variant="info" className="mt-2">
//                 Areas can be added to inactive divisions but won't be visible until division is activated.
//               </Alert>
//             </Form.Group>
//             <Form.Group controlId="formAreaName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Area Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g., Banani, Gulshan, Dhanmondi"
//                 value={addAreaForm.areaName}
//                 onChange={(e) => setAddAreaForm({ ...addAreaForm, areaName: e.target.value })}
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Initial Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="add-area-switch"
//                 label={addAreaForm.is_active ? "Active" : "Inactive"}
//                 checked={addAreaForm.is_active}
//                 onChange={(e) => setAddAreaForm({ ...addAreaForm, is_active: e.target.checked })}
//                 className="adminlocations-form-switch"
//               />
//             </Form.Group>
//             <Form.Group controlId="formCreatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Created by</Form.Label>
//               <Form.Control
//                 placeholder="Enter admin name (optional)"
//                 value={addAreaForm.created_by}
//                 onChange={(e) => setAddAreaForm({ ...addAreaForm, created_by: e.target.value })}
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setAddAreaOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitAddArea}
//           >
//             Create Area
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Add Division Modal */}
//       <Modal
//         show={addDivisionOpen}
//         onHide={() => setAddDivisionOpen(false)}
//         centered
//         className="adminlocations-modal"
//         dialogClassName="adminlocations-modal-xl"
//       >
//         <Modal.Header closeButton className="adminlocations-modal-header">
//           <Modal.Title className="w-100 text-center fw-bold">Add New Division</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminlocations-modal-body">
//           <Form onSubmit={submitAddDivision}>
//             <Form.Group controlId="formCountry" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Country</Form.Label>
//               <Form.Control
//                 value={country ? `${country.name} (${country.code})` : "No country available"}
//                 disabled
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formDivisionName" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g., Dhaka, Chittagong, Rajshahi"
//                 value={addDivisionForm.name}
//                 onChange={(e) => setAddDivisionForm({ ...addDivisionForm, name: e.target.value })}
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formDivisionCode" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Division Code</Form.Label>
//               <Form.Control
//                 placeholder="e.g., DHK, CTG, RAJ"
//                 value={addDivisionForm.code}
//                 onChange={(e) =>
//                   setAddDivisionForm({ ...addDivisionForm, code: e.target.value.toUpperCase() })
//                 }
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//             <Form.Group controlId="formStatus" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Initial Status</Form.Label>
//               <Form.Check
//                 type="switch"
//                 id="add-division-switch"
//                 label={addDivisionForm.is_active ? "Active" : "Inactive"}
//                 checked={addDivisionForm.is_active}
//                 onChange={(e) => setAddDivisionForm({ ...addDivisionForm, is_active: e.target.checked })}
//                 className="adminlocations-form-switch"
//               />
//               {!country?.is_active && addDivisionForm.is_active && (
//                 <Alert variant="warning" className="mt-2">
//                   Country is inactive. Activate country first.
//                 </Alert>
//               )}
//             </Form.Group>
//             <Form.Group controlId="formCreatedBy" className="mb-3">
//               <Form.Label className="adminlocations-form-label">Created by</Form.Label>
//               <Form.Control
//                 placeholder="Enter admin name (optional)"
//                 value={addDivisionForm.created_by}
//                 onChange={(e) => setAddDivisionForm({ ...addDivisionForm, created_by: e.target.value })}
//                 className="adminlocations-form-control"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminlocations-modal-footer">
//           <Button
//             variant="secondary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-close"
//             onClick={() => setAddDivisionOpen(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="adminlocations-footer-btn adminlocations-footer-btn-save"
//             onClick={submitAddDivision}
//           >
//             Create Division
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// }


// ***** Upper code all okay just here we update Auth (2-Dec-2025) ***** //
// ***** Locations with Admin Auth (1-Dec-2025) ***** //
import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Table,
  Button,
  Modal,
  Alert,
  Pagination,
} from "react-bootstrap";
import axios from "axios";
import { FaPlus, FaPencilAlt } from "react-icons/fa";
import "./Locations.css";
import { URL } from "../../../config";

// const API_BASE = "http://localhost:4001";
const DEFAULT_COUNTRY_CODE = "BD";

// ✅ Helper: build Authorization header for admin
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  if (!adminToken) return null;
  return {
    Authorization: `Bearer ${adminToken}`,
  };
};

// UPDATE: Prefer toLocaleString so time is reliably included everywhere
function fmtDate(d) {
  if (!d) return "--";
  try {
    return new Date(d).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return d;
  }
}

function StatusPill({ active }) {
  return (
    <span className={`adminlocations-badge-${active ? "active" : "inactive"}`}>
      {active ? "Active" : "Inactive"}
    </span>
  );
}

// UPDATE: toggle this if you want a soft data refresh when switching to Divisions
// (uses setRefreshKey; safer than window.location.reload() which would reset the tab)
const REFRESH_ON_DIVISIONS_TAB_CLICK = true;

export default function Locations() {
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  // UPDATE: separate pagination states for Areas and Divisions
  const [areasPage, setAreasPage] = useState(1);
  const [divisionsPage, setDivisionsPage] = useState(1);
  const itemsPerPage = 10;

  // country/division/area data
  const [country, setCountry] = useState(null);
  const [divisions, setDivisions] = useState([]);
  const [areas, setAreas] = useState([]);

  // UI state
  const [activeTab, setActiveTab] = useState("areas");

  // status modal
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusTarget, setStatusTarget] = useState(null);
  const [statusForm, setStatusForm] = useState({
    is_active: false,
    updated_by: "",
  });

  // add area modal
  const [addAreaOpen, setAddAreaOpen] = useState(false);
  const [addAreaForm, setAddAreaForm] = useState({
    divisionId: "",
    areaName: "",
    is_active: false,
    created_by: "",
  });

  // add division modal
  const [addDivisionOpen, setAddDivisionOpen] = useState(false);
  const [addDivisionForm, setAddDivisionForm] = useState({
    name: "",
    code: "",
    is_active: false,
    created_by: "",
  });

  // fetch tree & build state
  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const headers = getAdminHeaders();
        if (!headers) {
          if (!mounted) return;
          setErrorMessage("Not authorized. Please login as admin.");
          setLoading(false);
          return;
        }

        const res = await axios.get(`${URL}/locations/tree`, { headers });
        const data = res.data;

        const selected =
          data.find(
            (c) => (c.country?.code || "").toUpperCase() === DEFAULT_COUNTRY_CODE
          ) || data[0];

        if (!selected) {
          if (!mounted) return;
          setCountry(null);
          setDivisions([]);
          setAreas([]);
          setLoading(false);
          return;
        }

        const c = {
          id: selected.country.Id,
          name: selected.country.name,
          code: selected.country.code,
          is_active: selected.country.is_active,
          created_by: selected.country.created_by,
          updated_by: selected.country.updated_by,
          created_at: selected.country.created_at,
          updated_at: selected.country.updated_at,
        };

        const divs =
          (selected.divisions || []).map((d) => ({
            id: d.division.Id,
            name: d.division.name,
            code: d.division.code,
            is_active: d.division.is_active,
            created_by: d.division.created_by,
            updated_by: d.division.updated_by,
            created_at: d.division.created_at,
            updated_at: d.division.updated_at,
          })) || [];

        const flatAreas = [];
        (selected.divisions || []).forEach((d) => {
          const division = d.division;
          (d.areas || []).forEach((a) => {
            flatAreas.push({
              id: a.Id,
              areaName: a.name,
              is_active: a.is_active,
              created_by: a.created_by,
              updated_by: a.updated_by,
              created_at: a.created_at,
              updated_at: a.updated_at,
              divisionId: division.Id,
              divisionName: division.name,
              divisionCode: division.code,
              divisionActive: division.is_active,
            });
          });
        });

        divs.sort((a, b) => a.name.localeCompare(b.name));
        flatAreas.sort((x, y) => {
          const d = x.divisionName.localeCompare(y.divisionName);
          return d !== 0 ? d : x.areaName.localeCompare(y.areaName);
        });

        if (!mounted) return;
        setCountry(c);
        setDivisions(divs);
        setAreas(flatAreas);
      } catch (e) {
        console.error(e);
        if (e.response?.status === 401 || e.response?.status === 403) {
          setErrorMessage("Not authorized. Please login as admin.");
        } else {
          setErrorMessage("Failed to load locations. Check server/routes.");
        }
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [refreshKey]);

  // UPDATE: clamp areasPage when areas length changes
  useEffect(() => {
    const total = Math.max(1, Math.ceil(areas.length / itemsPerPage));
    if (areasPage > total) setAreasPage(total);
  }, [areas, itemsPerPage, areasPage]);

  // UPDATE: clamp divisionsPage when divisions length changes
  useEffect(() => {
    const total = Math.max(1, Math.ceil(divisions.length / itemsPerPage));
    if (divisionsPage > total) setDivisionsPage(total);
  }, [divisions, itemsPerPage, divisionsPage]);

  // Modal handlers
  const openAreaStatus = (row) => {
    setStatusTarget({
      type: "area",
      id: row.id,
      name: row.areaName,
      is_active: !!row.is_active,
      parentActive: !!row.divisionActive,
      parentName: row.divisionName,
      parentId: row.divisionId,
    });
    setStatusForm({ is_active: !!row.is_active, updated_by: "" });
    setStatusModalOpen(true);
  };

  const openDivisionStatus = (d) => {
    setStatusTarget({
      type: "division",
      id: d.id,
      name: d.name,
      code: d.code,
      is_active: !!d.is_active,
      parentActive: country ? !!country.is_active : true,
      parentName: country ? `${country.name} (${country.code})` : "--",
      parentId: country ? country.id : null,
    });
    setStatusForm({ is_active: !!d.is_active, updated_by: "" });
    setStatusModalOpen(true);
  };

  const openCountryStatus = () => {
    if (!country) return;
    setStatusTarget({
      type: "country",
      id: country.id,
      name: `${country.name} (${country.code})`,
      is_active: !!country.is_active,
    });
    setStatusForm({ is_active: !!country.is_active, updated_by: "" });
    setStatusModalOpen(true);
  };

  // Submit functions
  const submitStatus = async (e) => {
    e.preventDefault();
    if (!statusTarget) return;

    try {
      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      await axios.patch(
        `${URL}/locations/${statusTarget.id}/status`,
        {
          is_active: statusForm.is_active,
          updated_by: statusForm.updated_by || "admin",
        },
        { headers }
      );
      setStatusModalOpen(false);
      setStatusTarget(null);
      setRefreshKey((k) => k + 1);
      setErrorMessage("Status updated successfully.");
    } catch (e) {
      console.error(e);
      if (e.response?.status === 401 || e.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage(e.response?.data?.error || "Failed to update status");
      }
    }
  };

  const quickActivateParentThenArea = async () => {
    if (!statusTarget || statusTarget.type !== "area") return;
    const divisionId = statusTarget.parentId;
    try {
      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      await axios.patch(
        `${URL}/locations/${divisionId}/status`,
        {
          is_active: true,
          updated_by: statusForm.updated_by || "admin",
        },
        { headers }
      );
      await axios.patch(
        `${URL}/locations/${statusTarget.id}/status`,
        {
          is_active: true,
          updated_by: statusForm.updated_by || "admin",
        },
        { headers }
      );
      setStatusModalOpen(false);
      setStatusTarget(null);
      setRefreshKey((k) => k + 1);
      setErrorMessage("Parent and area activated successfully.");
    } catch (e) {
      console.error(e);
      if (e.response?.status === 401 || e.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage(e.response?.data?.error || "Failed to activate");
      }
    }
  };

  const openAddArea = () => {
    setAddAreaForm({
      divisionId: "",
      areaName: "",
      is_active: false,
      created_by: "",
    });
    setAddAreaOpen(true);
  };

  const submitAddArea = async (e) => {
    e.preventDefault();
    if (!addAreaForm.divisionId || !addAreaForm.areaName.trim()) {
      setErrorMessage("Please select a division and enter area name.");
      return;
    }
    try {
      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      await axios.post(
        `${URL}/locations/area`,
        {
          divisionId: Number(addAreaForm.divisionId),
          name: addAreaForm.areaName.trim(),
          created_by: addAreaForm.created_by || "admin",
          is_active: !!addAreaForm.is_active,
        },
        { headers }
      );
      setAddAreaOpen(false);
      setRefreshKey((k) => k + 1);
      setErrorMessage("Area created successfully.");
    } catch (e) {
      console.error(e);
      if (e.response?.status === 401 || e.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage(e.response?.data?.error || "Failed to create area");
      }
    }
  };

  const openAddDivision = () => {
    setAddDivisionForm({
      name: "",
      code: "",
      is_active: false,
      created_by: "",
    });
    setAddDivisionOpen(true);
  };

  const submitAddDivision = async (e) => {
    e.preventDefault();
    if (!country) {
      setErrorMessage("Please create/activate a country first.");
      return;
    }
    if (!addDivisionForm.name.trim() || !addDivisionForm.code.trim()) {
      setErrorMessage("Please enter division name and code.");
      return;
    }
    try {
      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      await axios.post(
        `${URL}/locations/division`,
        {
          countryCode: country.code || DEFAULT_COUNTRY_CODE,
          name: addDivisionForm.name.trim(),
          code: addDivisionForm.code.trim(),
          created_by: addDivisionForm.created_by || "admin",
          is_active: !!addDivisionForm.is_active,
        },
        { headers }
      );
      setAddDivisionOpen(false);
      setRefreshKey((k) => k + 1);
      setErrorMessage("Division created successfully.");
    } catch (e) {
      console.error(e);
      if (e.response?.status === 401 || e.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage(e.response?.data?.error || "Failed to create division");
      }
    }
  };

  // UPDATE: compute paged rows per tab (separate paginations)
  // Areas
  const indexOfLastArea = areasPage * itemsPerPage;
  const indexOfFirstArea = indexOfLastArea - itemsPerPage;
  const currentAreas = areas.slice(indexOfFirstArea, indexOfLastArea);
  const totalPagesAreas = Math.max(1, Math.ceil(areas.length / itemsPerPage));

  // Divisions
  const indexOfLastDivision = divisionsPage * itemsPerPage;
  const indexOfFirstDivision = indexOfLastDivision - itemsPerPage;
  const currentDivisions = divisions.slice(
    indexOfFirstDivision,
    indexOfLastDivision
  );
  const totalPagesDivisions = Math.max(
    1,
    Math.ceil(divisions.length / itemsPerPage)
  );

  // UPDATE: safe type title for modal
  const typeTitle = statusTarget
    ? (statusTarget.type?.[0]?.toUpperCase() || "") +
      (statusTarget.type?.slice(1) || "")
    : "";

  return (
    <Container fluid className="adminlocations-container">
      {errorMessage && (
        <Alert
          variant={errorMessage.includes("successfully") ? "success" : "danger"}
          onClose={() => setErrorMessage("")}
          dismissible
          className="adminlocations-alert"
        >
          {errorMessage}
        </Alert>
      )}
      <Card className="adminlocations-card">
        <Card.Header className="adminlocations-header">
          <h4 className="adminlocations-title">Location Management</h4>
        </Card.Header>
        <Card.Body>
          {/* Country status bar */}
          <div className="adminlocations-country-bar">
            {country ? (
              <>
                <div className="adminlocations-country-info">
                  <div className="adminlocations-country-title">
                    Country:&nbsp;<strong>{country.name}</strong>
                    {country.code ? <span>&nbsp;({country.code})</span> : null}
                  </div>
                  <StatusPill active={country.is_active} />
                  <span className="ms-2">
                    • {divisions.length} divisions • {areas.length} areas
                  </span>
                </div>
                <div className="adminlocations-country-actions">
                  {/* UPDATE: pill-style editable button */}
                  <Button
                    variant="none"
                    className="adminlocations-edit-pill"
                    onClick={openCountryStatus}
                  >
                    <FaPencilAlt className="me-2" /> Manage Status
                  </Button>
                </div>
              </>
            ) : (
              <div className="adminlocations-empty">
                No country found. Please create a country first.
              </div>
            )}
          </div>

          {/* Tabs */}
          <div className="adminlocations-tabs">
            <Button
              variant={activeTab === "areas" ? "primary" : "outline-primary"}
              className="adminlocations-tab-btn"
              onClick={() => {
                // UPDATE: reset page on tab change
                setActiveTab("areas");
                setAreasPage(1);
              }}
            >
              Areas ({areas.length})
            </Button>
            <Button
              variant={
                activeTab === "divisions" ? "primary" : "outline-primary"
              }
              className="adminlocations-tab-btn"
              onClick={() => {
                // UPDATE: reset page on tab change
                setActiveTab("divisions");
                setDivisionsPage(1);
                if (REFRESH_ON_DIVISIONS_TAB_CLICK) {
                  // soft refresh from server (keeps current tab)
                  setRefreshKey((k) => k + 1);
                  // If you truly want a full window reload, uncomment:
                  // window.location.reload();
                }
              }}
            >
              Divisions ({divisions.length})
            </Button>
          </div>

          {/* Tab content */}
          {activeTab === "areas" ? (
            <>
              <div className="adminlocations-card-head">
                <h3>Service Areas</h3>
                <Button
                  className="adminlocations-add-btn"
                  onClick={openAddArea}
                >
                  <FaPlus size={20} /> Add Area
                </Button>
              </div>
              {loading ? (
                <div className="adminlocations-loading">Loading…</div>
              ) : currentAreas.length === 0 ? (
                <div className="adminlocations-empty">
                  No areas found. Start by creating your first service area.
                  <Button
                    variant="primary"
                    className="ms-2"
                    onClick={openAddArea}
                  >
                    Add Area
                  </Button>
                </div>
              ) : (
                <>
                  <div className="adminlocations-table-wrap">
                    <Table
                      striped
                      hover
                      size="sm"
                      className="adminlocations-table"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Division</th>
                          <th>Code</th>
                          <th>Area</th>
                          <th>Status</th>
                          <th>Created by</th>
                          <th>Updated by</th>
                          <th>Created at</th>
                          <th>Updated at</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentAreas.map((row, idx) => (
                          <tr key={row.id}>
                            <td>{indexOfFirstArea + idx + 1}</td>
                            <td>
                              {row.divisionName}
                              {!row.divisionActive && (
                                <span className="badge bg-warning text-dark ms-2">
                                  Division Inactive
                                </span>
                              )}
                            </td>
                            <td>{row.divisionCode || "—"}</td>
                            <td>{row.areaName}</td>
                            <td>
                              <StatusPill active={row.is_active} />
                            </td>
                            <td>{row.created_by || "—"}</td>
                            <td>{row.updated_by || "—"}</td>
                            <td>{fmtDate(row.created_at)}</td>
                            <td>{fmtDate(row.updated_at)}</td>
                            <td>
                              <Button
                                variant="none"
                                className="adminlocations-action-btn"
                                onClick={() => openAreaStatus(row)}
                              >
                                <FaPencilAlt
                                  size={16}
                                  style={{ color: "#0d6efd" }}
                                />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  {/* UPDATE: Areas pagination uses areasPage */}
                  <Pagination className="adminlocations-pagination">
                    <Pagination.First
                      onClick={() => setAreasPage(1)}
                      disabled={areasPage === 1}
                    />
                    <Pagination.Prev
                      onClick={() => setAreasPage(areasPage - 1)}
                      disabled={areasPage === 1}
                    />
                    {[...Array(totalPagesAreas).keys()].map((i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === areasPage}
                        onClick={() => setAreasPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => setAreasPage(areasPage + 1)}
                      disabled={areasPage === totalPagesAreas}
                    />
                    <Pagination.Last
                      onClick={() => setAreasPage(totalPagesAreas)}
                      disabled={areasPage === totalPagesAreas}
                    />
                  </Pagination>
                </>
              )}
            </>
          ) : (
            <>
              <div className="adminlocations-card-head">
                <h3>Divisions</h3>
                <Button
                  className="adminlocations-add-btn"
                  onClick={openAddDivision}
                >
                  <FaPlus size={20} /> Add Division
                </Button>
              </div>
              {loading ? (
                <div className="adminlocations-loading">Loading…</div>
              ) : currentDivisions.length === 0 ? (
                <div className="adminlocations-empty">
                  No divisions found. Start by creating your first division.
                  <Button
                    variant="primary"
                    className="ms-2"
                    onClick={openAddDivision}
                  >
                    Add Division
                  </Button>
                </div>
              ) : (
                <>
                  <div className="adminlocations-table-wrap">
                    <Table
                      striped
                      hover
                      size="sm"
                      className="adminlocations-table"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Division</th>
                          <th>Code</th>
                          <th>Status</th>
                          <th>Areas</th>
                          <th>Created by</th>
                          <th>Updated by</th>
                          <th>Created at</th>
                          <th>Updated at</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentDivisions.map((d, idx) => {
                          const areaCount = areas.filter(
                            (a) => a.divisionId === d.id
                          ).length;
                          const activeAreaCount = areas.filter(
                            (a) => a.is_active && a.divisionId === d.id
                          ).length;
                          return (
                            <tr key={d.id}>
                              <td>{indexOfFirstDivision + idx + 1}</td>
                              <td>{d.name}</td>
                              <td>{d.code || "—"}</td>
                              <td>
                                <StatusPill active={d.is_active} />
                              </td>
                              <td>
                                {activeAreaCount}/{areaCount}
                              </td>
                              <td>{d.created_by || "—"}</td>
                              <td>{d.updated_by || "—"}</td>
                              <td>{fmtDate(d.created_at)}</td>
                              <td>{fmtDate(d.updated_at)}</td>
                              <td>
                                <Button
                                  variant="none"
                                  className="adminlocations-action-btn"
                                  onClick={() => openDivisionStatus(d)}
                                >
                                  <FaPencilAlt
                                    size={16}
                                    style={{ color: "#0d6efd" }}
                                  />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  {/* UPDATE: Divisions pagination uses divisionsPage */}
                  <Pagination className="adminlocations-pagination">
                    <Pagination.First
                      onClick={() => setDivisionsPage(1)}
                      disabled={divisionsPage === 1}
                    />
                    <Pagination.Prev
                      onClick={() => setDivisionsPage(divisionsPage - 1)}
                      disabled={divisionsPage === 1}
                    />
                    {[...Array(totalPagesDivisions).keys()].map((i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === divisionsPage}
                        onClick={() => setDivisionsPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => setDivisionsPage(divisionsPage + 1)}
                      disabled={divisionsPage === totalPagesDivisions}
                    />
                    <Pagination.Last
                      onClick={() => setDivisionsPage(totalPagesDivisions)}
                      disabled={divisionsPage === totalPagesDivisions}
                    />
                  </Pagination>
                </>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Status Modal */}
      <Modal
        show={statusModalOpen}
        onHide={() => setStatusModalOpen(false)}
        centered
        className="adminlocations-modal"
        dialogClassName="adminlocations-modal-xl"
      >
        <Modal.Header
          closeButton
          className="adminlocations-modal-header"
        >
          <Modal.Title className="w-100 text-center fw-bold">
            {statusTarget
              ? `Update ${typeTitle} Status: ${
                  statusTarget.type === "country"
                    ? statusTarget.name
                    : statusTarget.type === "division"
                    ? `${
                        statusTarget.name
                      }${
                        statusTarget.code
                          ? ` (${statusTarget.code})`
                          : ""
                      }`
                    : statusTarget.name
                }`
              : "Update Status"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminlocations-modal-body">
          <Form onSubmit={submitStatus}>
            {statusTarget && statusTarget.type !== "country" && (
              <Form.Group controlId="formParent" className="mb-3">
                <Form.Label className="adminlocations-form-label">
                  {statusTarget?.type === "area" ? "Division" : "Country"}
                </Form.Label>
                <Form.Control
                  value={statusTarget?.parentName ?? "--"}
                  disabled
                  className="adminlocations-form-control"
                />
              </Form.Group>
            )}
            <Form.Group controlId="formName" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                {statusTarget?.type === "area"
                  ? "Area Name"
                  : statusTarget?.type === "division"
                  ? "Division Name"
                  : "Country Name"}
              </Form.Label>
              <Form.Control
                value={statusTarget?.name || ""}
                disabled
                className="adminlocations-form-control"
              />
            </Form.Group>
            <Form.Group controlId="formStatus" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Status
              </Form.Label>
              <Form.Check
                type="switch"
                id="status-switch"
                label={statusForm.is_active ? "Active" : "Inactive"}
                checked={statusForm.is_active}
                onChange={(e) =>
                  setStatusForm({
                    ...statusForm,
                    is_active: e.target.checked,
                  })
                }
                className="adminlocations-form-switch adminlocations-switch-label-down"
              />
              {statusForm.is_active &&
                statusTarget?.parentActive === false && (
                  <Alert variant="warning" className="mt-2">
                    Parent is inactive. Activate the parent first, otherwise
                    this cannot be turned on.
                  </Alert>
                )}
            </Form.Group>
            <Form.Group controlId="formUpdatedBy" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Updated by
              </Form.Label>
              <Form.Control
                placeholder="Enter admin name (optional)"
                value={statusForm.updated_by}
                onChange={(e) =>
                  setStatusForm({
                    ...statusForm,
                    updated_by: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
            {statusTarget?.type === "area" &&
              statusForm.is_active &&
              statusTarget?.parentActive === false && (
                <Button
                  variant="warning"
                  className="adminlocations-footer-btn adminlocations-footer-btn-quick"
                  onClick={quickActivateParentThenArea}
                >
                  Activate Division & Save
                </Button>
              )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="adminlocations-modal-footer">
          <Button
            variant="secondary"
            className="adminlocations-footer-btn adminlocations-footer-btn-close"
            onClick={() => setStatusModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="adminlocations-footer-btn adminlocations-footer-btn-save"
            onClick={submitStatus}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Area Modal */}
      <Modal
        show={addAreaOpen}
        onHide={() => setAddAreaOpen(false)}
        centered
        className="adminlocations-modal"
        dialogClassName="adminlocations-modal-xl"
      >
        <Modal.Header
          closeButton
          className="adminlocations-modal-header"
        >
          <Modal.Title className="w-100 text-center fw-bold">
            Add New Area
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminlocations-modal-body">
          <Form onSubmit={submitAddArea}>
            <Form.Group controlId="formDivision" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Division
              </Form.Label>
              <Form.Select
                value={addAreaForm.divisionId}
                onChange={(e) =>
                  setAddAreaForm({
                    ...addAreaForm,
                    divisionId: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              >
                <option value="">Select a division</option>
                {divisions.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} {d.code ? `(${d.code})` : ""}
                    {!d.is_active ? " - INACTIVE" : ""}
                  </option>
                ))}
              </Form.Select>
              <Alert variant="info" className="mt-2">
                Areas can be added to inactive divisions but won't be visible
                until division is activated.
              </Alert>
            </Form.Group>
            <Form.Group controlId="formAreaName" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Area Name
              </Form.Label>
              <Form.Control
                placeholder="e.g., Banani, Gulshan, Dhanmondi"
                value={addAreaForm.areaName}
                onChange={(e) =>
                  setAddAreaForm({
                    ...addAreaForm,
                    areaName: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
            <Form.Group controlId="formStatus" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Initial Status
              </Form.Label>
              <Form.Check
                type="switch"
                id="add-area-switch"
                label={addAreaForm.is_active ? "Active" : "Inactive"}
                checked={addAreaForm.is_active}
                onChange={(e) =>
                  setAddAreaForm({
                    ...addAreaForm,
                    is_active: e.target.checked,
                  })
                }
                className="adminlocations-form-switch"
              />
            </Form.Group>
            <Form.Group controlId="formCreatedBy" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Created by
              </Form.Label>
              <Form.Control
                placeholder="Enter admin name (optional)"
                value={addAreaForm.created_by}
                onChange={(e) =>
                  setAddAreaForm({
                    ...addAreaForm,
                    created_by: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="adminlocations-modal-footer">
          <Button
            variant="secondary"
            className="adminlocations-footer-btn adminlocations-footer-btn-close"
            onClick={() => setAddAreaOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="adminlocations-footer-btn adminlocations-footer-btn-save"
            onClick={submitAddArea}
          >
            Create Area
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Division Modal */}
      <Modal
        show={addDivisionOpen}
        onHide={() => setAddDivisionOpen(false)}
        centered
        className="adminlocations-modal"
        dialogClassName="adminlocations-modal-xl"
      >
        <Modal.Header
          closeButton
          className="adminlocations-modal-header"
        >
          <Modal.Title className="w-100 text-center fw-bold">
            Add New Division
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminlocations-modal-body">
          <Form onSubmit={submitAddDivision}>
            <Form.Group controlId="formCountry" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Country
              </Form.Label>
              <Form.Control
                value={
                  country
                    ? `${country.name} (${country.code})`
                    : "No country available"
                }
                disabled
                className="adminlocations-form-control"
              />
            </Form.Group>
            <Form.Group controlId="formDivisionName" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Division Name
              </Form.Label>
              <Form.Control
                placeholder="e.g., Dhaka, Chittagong, Rajshahi"
                value={addDivisionForm.name}
                onChange={(e) =>
                  setAddDivisionForm({
                    ...addDivisionForm,
                    name: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
            <Form.Group controlId="formDivisionCode" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Division Code
              </Form.Label>
              <Form.Control
                placeholder="e.g., DHK, CTG, RAJ"
                value={addDivisionForm.code}
                onChange={(e) =>
                  setAddDivisionForm({
                    ...addDivisionForm,
                    code: e.target.value.toUpperCase(),
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
            <Form.Group controlId="formStatus" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Initial Status
              </Form.Label>
              <Form.Check
                type="switch"
                id="add-division-switch"
                label={addDivisionForm.is_active ? "Active" : "Inactive"}
                checked={addDivisionForm.is_active}
                onChange={(e) =>
                  setAddDivisionForm({
                    ...addDivisionForm,
                    is_active: e.target.checked,
                  })
                }
                className="adminlocations-form-switch"
              />
              {!country?.is_active &&
                addDivisionForm.is_active && (
                  <Alert variant="warning" className="mt-2">
                    Country is inactive. Activate country first.
                  </Alert>
                )}
            </Form.Group>
            <Form.Group controlId="formCreatedBy" className="mb-3">
              <Form.Label className="adminlocations-form-label">
                Created by
              </Form.Label>
              <Form.Control
                placeholder="Enter admin name (optional)"
                value={addDivisionForm.created_by}
                onChange={(e) =>
                  setAddDivisionForm({
                    ...addDivisionForm,
                    created_by: e.target.value,
                  })
                }
                className="adminlocations-form-control"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="adminlocations-modal-footer">
          <Button
            variant="secondary"
            className="adminlocations-footer-btn adminlocations-footer-btn-close"
            onClick={() => setAddDivisionOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="adminlocations-footer-btn adminlocations-footer-btn-save"
            onClick={submitAddDivision}
          >
            Create Division
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
